import type { Translations } from './en.js';

const th: Translations = {
  ok: 'ตกลง', cancel: 'ยกเลิก', close: 'ปิด', confirm: 'ยืนยัน', retry: 'ลองใหม่', back: 'ย้อนกลับ', settings: 'การตั้งค่า', language: 'ภาษา',
  score: 'คะแนน', level: 'ระดับ', game_over: 'เกมจบแล้ว', restart: 'เริ่มใหม่', pause: 'หยุดชั่วคราว', resume: 'ดำเนินต่อ',
  settings_sound: 'เสียง', settings_music: 'ดนตรี', settings_reset: 'รีเซ็ตเกม', settings_reset_confirm: 'รีเซ็ตความคืบหน้าทั้งหมด?',
  ad_watch: 'ดูโฆษณา', ad_reward: 'รางวัลฟรี', ad_loading: 'กำลังโหลดโฆษณา...', ad_reward_received: 'ได้รับรางวัลแล้ว!', ad_not_completed: 'โฆษณายังไม่เสร็จ',
  offline_title: 'ยินดีต้อนรับกลับ!', offline_earned: 'ได้รับขณะออฟไลน์',
  sp: 'SP', fame: 'ชื่อเสียง', building_tab: 'อาคาร', ghosts_tab: 'ผี', shop_tab: 'ร้านค้า', prestige_tab: 'เกียรติยศ',
  training_tab: 'ฝึกซ้อม', facilities_tab: 'สิ่งอำนวยความสะดวก', reviews_tab: 'รีวิว',
  floor_label: 'ชั้น {n}', buy_floor: 'ซื้อชั้น', buy_floor_cost: 'ซื้อชั้น ({sp} SP)', unlock_slot: 'ปลดล็อกสล็อต', unlock_slot_cost: 'ปลดล็อกสล็อต ({sp} SP)',
  build_room: 'สร้างห้อง', upgrade_room: 'อัปเกรดห้อง', upgrade_room_cost: 'อัปเกรด ({sp} SP)', room_empty: 'ว่าง', room_locked: 'ล็อค',
  no_ghost: 'ไม่มีผี', assign_ghost: 'มอบหมายผี', visitors_floor: 'ผู้เยี่ยมชมในชั้นนี้',
  add_floor: 'เพิ่มชั้น', add_floor_cost: '+ ชั้นใหม่ ({sp} SP)', menu_tab: 'เมนู',
  room_dark_corridor: 'ทางเดินมืด', room_dark_corridor_desc: 'ความกลัวทางจิต +30%',
  room_mirror_room: 'ห้องกระจก', room_mirror_room_desc: 'ภาพ +25%, จิต +15%',
  room_dungeon: 'คุกใต้ดิน', room_dungeon_desc: 'จิต +20%, กายภาพ +20%',
  room_graveyard: 'ห้องสุสาน', room_graveyard_desc: 'ความกลัวทางจิต +40%',
  room_lab: 'ห้องทดลอง', room_lab_desc: 'ภาพ +30%, กายภาพ +20%',
  room_library: 'ห้องสมุด', room_library_desc: 'จิต +35%, การได้ยิน +15%',
  room_coffin_room: 'ห้องโลงศพ', room_coffin_room_desc: 'ภาพ +30%, จิต +20%',
  room_doll_room: 'ห้องตุ๊กตา', room_doll_room_desc: 'ภาพ +20%, จิต +35%',
  room_kitchen: 'ห้องครัวต้องสาป', room_kitchen_desc: 'กายภาพ +30%, การได้ยิน +20%',
  room_bathroom: 'ห้องน้ำผีสิง', room_bathroom_desc: 'จิต +30%, การได้ยิน +25%',
  room_funhouse: 'บ้านกระจก',
  room_funhouse_desc: 'สายตา+35%, จิตวิทยา+20%',
  room_trapeze_room: 'ห้องทราพีซ',
  room_trapeze_room_desc: 'กายภาพ+30%, สายตา+15%',
  room_freak_show: 'รายการสยอง',
  room_freak_show_desc: 'สายตา+40%, จิตวิทยา+30%',
  room_sacrifice_altar: 'แท่นบูชา',
  room_sacrifice_altar_desc: 'จิตวิทยา+40%, สายตา+20%',
  room_treasure_vault: 'ห้องนิรภัย',
  room_treasure_vault_desc: 'จิตวิทยา+20%, การได้ยิน+20%',
  room_underground_river: 'แม่น้ำใต้ดิน',
  room_underground_river_desc: 'การได้ยิน+30%, จิตวิทยา+20%',
  room_curse_chamber: 'ห้องคำสาป',
  room_curse_chamber_desc: 'จิตวิทยา+45%, กายภาพ+15%',
  room_mummy_tomb: 'หลุมฝังศพมัมมี่',
  room_mummy_tomb_desc: 'สายตา+30%, จิตวิทยา+30%',
  room_captain_cabin: 'ห้องกัปตัน',
  room_captain_cabin_desc: 'จิตวิทยา+30%, สายตา+20%',
  room_cargo_hold: 'ห้องเก็บสินค้า',
  room_cargo_hold_desc: 'กายภาพ+25%, การได้ยิน+20%',
  room_davy_jones_locker: 'ห้องนิรภัยเดวี่ โจนส์',
  room_davy_jones_locker_desc: 'จิตวิทยา+35%, สายตา+25%',
  room_brig: 'ห้องขังเรือ',
  room_brig_desc: 'กายภาพ+30%, จิตวิทยา+20%',
  room_crows_nest: 'รังกาเหว่า',
  room_crows_nest_desc: 'กายภาพ+35%, สายตา+20%',
  room_mine_shaft: 'อุโมงค์เหมือง',
  room_mine_shaft_desc: 'กายภาพ+30%, การได้ยิน+20%',
  room_crystal_cave: 'ถ้ำผลึก',
  room_crystal_cave_desc: 'สายตา+35%, การได้ยิน+15%',
  room_explosives_storage: 'คลังวัตถุระเบิด',
  room_explosives_storage_desc: 'กายภาพ+40%, การได้ยิน+25%',
  room_underground_lake: 'ทะเลสาบใต้ดิน',
  room_underground_lake_desc: 'จิตวิทยา+30%, การได้ยิน+25%',
  room_rail_tunnel: 'อุโมงค์รถไฟ',
  room_rail_tunnel_desc: 'กายภาพ+30%, จิตวิทยา+20%',
  room_throne_room: 'ห้องบัลลังก์',
  room_throne_room_desc: 'สายตา+25%, จิตวิทยา+30%',
  room_wine_cellar: 'ห้องเก็บไวน์',
  room_wine_cellar_desc: 'จิตวิทยา+30%, สายตา+15%',
  room_tower_chamber: 'ห้องหอคอย',
  room_tower_chamber_desc: 'จิตวิทยา+35%, กายภาพ+20%',
  room_server_room: 'ห้องเซิร์ฟเวอร์',
  room_server_room_desc: 'การได้ยิน+30%, สายตา+20%',
  room_quarantine_zone: 'เขตกักกัน',
  room_quarantine_zone_desc: 'จิตวิทยา+35%, กายภาพ+20%',
  room_armory: 'คลังแสง',
  room_armory_desc: 'กายภาพ+35%, สายตา+20%',
  room_witch_hut: 'กระท่อมแม่มด',
  room_witch_hut_desc: 'สายตา+30%, จิตวิทยา+25%',
  room_treehouse: 'บ้านต้นไม้',
  room_treehouse_desc: 'กายภาพ+25%, การได้ยิน+20%',
  room_swamp_path: 'ทางเดินบึง',
  room_swamp_path_desc: 'จิตวิทยา+30%, การได้ยิน+20%',
  room_fairy_ring: 'วงแหวนนางฟ้า',
  room_fairy_ring_desc: 'จิตวิทยา+40%, สายตา+20%',
  room_ancient_ruin: 'ซากโบราณ',
  room_ancient_ruin_desc: 'จิตวิทยา+35%, สายตา+25%',
  room_attic: 'ห้องใต้หลังคา',
  room_attic_desc: 'จิตวิทยา+30%, การได้ยิน+15%',
  room_secret_passage: 'ทางลับ',
  room_secret_passage_desc: 'จิตวิทยา+35%, กายภาพ+15%',
  room_morgue: 'ห้องเก็บศพ',
  room_morgue_desc: 'สายตา+30%, จิตวิทยา+30%',
  room_surgery_room: 'ห้องผ่าตัด',
  room_surgery_room_desc: 'กายภาพ+35%, สายตา+25%',
  room_music_room: 'ห้องดนตรี',
  room_music_room_desc: 'การได้ยิน+40%, จิตวิทยา+20%',
  room_science_lab: 'ห้องปฏิบัติการวิทยาศาสตร์',
  room_science_lab_desc: 'สายตา+30%, กายภาพ+25%',
  room_ticket_booth: 'ตู้ขายตั๋ว',
  room_ticket_booth_desc: 'จิตวิทยา+25%, สายตา+20%',
  room_animal_cage: 'กรงสัตว์',
  room_animal_cage_desc: 'กายภาพ+30%, สายตา+25%',
  room_clown_tent: 'เต็นท์ตัวตลก',
  room_clown_tent_desc: 'จิตวิทยา+40%, สายตา+20%',
  room_hall_of_mirrors: 'ห้องกระจก',
  room_hall_of_mirrors_desc: 'สายตา+40%, จิตวิทยา+30%',
  room_elevator_shaft: 'ปล่องลิฟต์',
  room_elevator_shaft_desc: 'กายภาพ+35%, จิตวิทยา+20%',
  room_ore_processing: 'โรงแต่งแร่',
  room_ore_processing_desc: 'การได้ยิน+30%, กายภาพ+20%',
  room_collapsed_tunnel: 'อุโมงค์ถล่ม',
  room_collapsed_tunnel_desc: 'กายภาพ+40%, จิตวิทยา+25%',
  room_miners_quarters: 'ที่พักคนงาน',
  room_miners_quarters_desc: 'จิตวิทยา+30%, สายตา+20%',
  room_command_center: 'ศูนย์บัญชาการ',
  room_command_center_desc: 'จิตวิทยา+30%, การได้ยิน+25%',
  room_ventilation_shaft: 'ท่อระบายอากาศ',
  room_ventilation_shaft_desc: 'กายภาพ+35%, การได้ยิน+25%',
  room_decontamination: 'ห้องฆ่าเชื้อ',
  room_decontamination_desc: 'จิตวิทยา+35%, สายตา+25%',
  room_hollow_tree: 'ต้นไม้กลวง',
  room_hollow_tree_desc: 'สายตา+30%, จิตวิทยา+25%',
  room_spider_nest: 'รังแมงมุม',
  room_spider_nest_desc: 'สายตา+35%, กายภาพ+25%',
  room_moonlit_clearing: 'ทุ่งแสงจันทร์',
  room_moonlit_clearing_desc: 'จิตวิทยา+40%, การได้ยิน+20%',
  room_abandoned_cabin: 'กระท่อมร้าง',
  room_abandoned_cabin_desc: 'จิตวิทยา+30%, สายตา+20%',

  room_ward_room: 'ห้องผู้ป่วย',
  room_ward_room_desc: 'จิตวิทยา+30%, สายตา+20%',
  room_reception_hall: 'ห้องต้อนรับ',
  room_reception_hall_desc: 'จิตวิทยา+25%, การได้ยิน+20%',
  room_x_ray_room: 'ห้องเอ็กซเรย์',
  room_x_ray_room_desc: 'สายตา+35%, กายภาพ+20%',
  room_classroom: 'ห้องเรียน',
  room_classroom_desc: 'จิตวิทยา+30%, การได้ยิน+15%',
  room_art_room: 'ห้องศิลปะ',
  room_art_room_desc: 'สายตา+35%, จิตวิทยา+20%',
  room_gymnasium: 'โรงยิม',
  room_gymnasium_desc: 'กายภาพ+30%, การได้ยิน+25%',
  room_rooftop: 'ดาดฟ้า',
  room_rooftop_desc: 'จิตวิทยา+40%, กายภาพ+20%',
  room_crypt: 'ห้องใต้ดินเก็บศพ',
  room_crypt_desc: 'สายตา+35%, จิตวิทยา+25%',
  room_powder_room: 'ห้องดินปืน',
  room_powder_room_desc: 'กายภาพ+40%, การได้ยิน+20%',
  room_navigation_room: 'ห้องเดินเรือ',
  room_navigation_room_desc: 'จิตวิทยา+30%, สายตา+20%',
  room_banquet_hall: 'ห้องจัดเลี้ยง',
  room_banquet_hall_desc: 'จิตวิทยา+30%, สายตา+20%',
  room_chapel: 'โบสถ์',
  room_chapel_desc: 'จิตวิทยา+40%, การได้ยิน+20%',
  room_torture_chamber: 'ห้องทรมาน',
  room_torture_chamber_desc: 'กายภาพ+40%, สายตา+30%',
  room_armory_hall: 'ห้องแสดงอาวุธ',
  room_armory_hall_desc: 'กายภาพ+30%, สายตา+25%',
  room_science_room: 'ห้องวิจัย',
  room_science_room_desc: 'สายตา+30%, จิตวิทยา+20%',

  unlock_requires_day: 'วันที่ {n}+',
  unlock_requires_fame: 'ชื่อเสียง {n}+',
  unlock_requires_room: 'ต้องการ: {name}',
  unlock_condition_not_met: 'ไม่ตรงตามเงื่อนไข',
  room_repair_needed: 'ต้องซ่อมแซม', room_repairing: 'กำลังซ่อมแซม', room_cleaning: 'กำลังทำความสะอาด',
  ghost_roster: 'รายชื่อผี', ghost_idle: 'ว่าง', ghost_assigned: 'มอบหมายแล้ว', ghost_fatigue: 'ความเมื่อยล้า',
  ghost_level: 'Lv.{n}', ghost_exp: 'EXP {cur}/{max}', ghost_level_up: 'เลเวลอัพ',
  recover_fatigue: 'ฟื้นฟูความเมื่อยล้า ({sp} SP)', ghost_fatigued_warning: 'หมดแรง! ประสิทธิภาพ -50%', unassign_ghost: 'ยกเลิกการมอบหมาย',
  ghost_training_in_progress: 'กำลังฝึก...',
  shop_ghosts: 'จ้างผี', shop_rooms: 'ประเภทห้อง', hire: 'จ้าง', hire_cost: '{sp} SP', already_hired: 'จ้างแล้ว',
  not_enough_sp: 'SP ไม่พอ!', unlock_room_type: 'ปลดล็อก', unlock_cost: '{sp} SP', already_unlocked: 'ปลดล็อกแล้ว',
  grade_c: 'เกรด C', grade_b: 'เกรด B', grade_a: 'เกรด A', grade_s: 'เกรด S',
  ghost_jinaeryeong: 'ผีหญิงเกาหลี', ghost_gangsi: 'เจียงชี', ghost_vampire: 'แวมไพร์', ghost_kappa: 'คัปปะ', ghost_pierrot: 'ตัวตลก', ghost_banshee: 'แบนชี',
  ghost_origin_korea: 'เกาหลี', ghost_origin_china: 'จีน', ghost_origin_romania: 'โรมาเนีย', ghost_origin_japan: 'ญี่ปุ่น', ghost_origin_usa: 'สหรัฐอเมริกา', ghost_origin_ireland: 'ไอร์แลนด์',
  ghost_jinaeryeong_skill: 'ผมหล่น: ตกจากเพดานเพิ่มความกลัวทางกายภาพ',
  ghost_gangsi_skill: 'กระโดดแข็งทื่อ: กระโดดอย่างแข็งทื่อ ทำให้ผู้เยี่ยมชม 2 คนกลัว',
  ghost_vampire_skill: 'ดวงตาสะกดจิต: แช่แข็งผู้เยี่ยมชม 1 คน 10 วินาที ห้องถัดไป +30%',
  ghost_kappa_skill: 'หมุนจาน: หมุนจานบนหัวสร้างความกลัวทางภาพ',
  ghost_pierrot_skill: 'โจมตีเสียงหัวเราะ: ปรากฏตัวอย่างกะทันหัน ความกลัวตัวตลก',
  ghost_banshee_skill: 'กรีดร้อง: ความกลัวทางเสียงสูงสุด สามารถเปิดใช้งานได้หลายครั้ง',
  ghost_jinaeryeong_quote: 'วันนี้ทำให้ผู้เยี่ยมชม 10 คนกลัวแล้วนายจ้าง!', ghost_gangsi_quote: 'การกระโดดยากมาก...',
  ghost_vampire_quote: 'คืนยาวนาน และฉันเป็นอมตะ', ghost_kappa_quote: 'อย่าหกน้ำ!',
  ghost_pierrot_quote: 'ทำไมต้องจริงจังขนาดนั้น?', ghost_banshee_quote: 'คอเจ็บจากการร้องมาก',
  ghost_jinaeryeong_fatigued: 'นายจ้าง... ผมกระจายทั่ว ต้องพักแล้ว!',
  ghost_gangsi_fatigued: 'ฉันเคลื่อนไม่ได้แล้ว... จริงๆ', ghost_vampire_fatigued: 'แม้แต่อมตะก็ต้องพัก...',
  ghost_kappa_fatigued: 'จานแห้งแล้ว ต้องการน้ำ!', ghost_pierrot_fatigued: 'ฉันหัวเราะไม่ออกแล้วนายจ้าง',
  ghost_banshee_fatigued: 'เสียงหายไปแล้ว! ร้องไม่ออก!',
  room_unlock_in_shop: 'ปลดล็อกในร้านค้า',
  visitor_scaredy_kid: 'เด็กขี้กลัว', visitor_scaredy_kid_desc: 'ตกใจง่ายแต่พอใจง่าย',
  visitor_normal: 'ผู้เยี่ยมชม', visitor_normal_desc: 'ความทนทานต่อความกลัวปานกลาง',
  visitor_brave: 'คนกล้า', visitor_brave_desc: 'ทนทานสูง รางวัลมากเมื่อพอใจ',
  visitor_couple: 'คู่รัก', visitor_couple_desc: 'กลัวปานกลาง รางวัลสูง รีวิวดี',
  visitor_youtuber: 'ยูทูบเบอร์', visitor_youtuber_desc: 'รีวิวมีอิทธิพล 2.5 เท่า',
  visitor_exorcist: 'หมอผี', visitor_exorcist_desc: 'แทบเป็นไปไม่ได้ที่จะทำให้กลัว รางวัลมหาศาล',
  visitor_thrill_seeker: 'คนชอบสยอง', visitor_thrill_seeker_desc: 'ต้องการความกลัวเข้มข้น ใจร้อนกับแบบอ่อน',
  visitor_coward: 'คนขี้กลัว', visitor_coward_desc: 'กลัวทุกอย่าง หนีง่าย',
  time_phase_day: 'กลางวัน', time_phase_evening: 'เย็น', time_phase_night: 'กลางคืน', time_phase_rain: 'ฝน',
  reputation_label: 'ชื่อเสียง: {n}',
  scare_chain: 'ลูกโซ่ x{n}!', terror_max: 'ความกลัวสูงสุด!', sp_earned: '+{sp} SP',
  prestige_title: 'ขยายแฟรนไชส์', prestige_desc: 'บ้านผีสิงของคุณโด่งดังทั่วโลก! เปิดแฟรนไชส์?',
  prestige_requirement_floors: 'ต้องการ {n} ชั้น', prestige_requirement_fame: 'ต้องการชื่อเสียง {n}',
  prestige_requirement_sp: 'ต้องการ SP รวม {n}', prestige_not_ready: 'ยังไม่ตรงตามเงื่อนไข',
  prestige_confirm: 'เปิดแฟรนไชส์', prestige_level: 'เกียรติยศ Lv.{n}',
  prestige_bonus: 'ผีทั้งหมด +{n}% ความกลัว, SP เริ่มต้น +{sp}', offline_collect: 'รับ',

  training_title: 'คลาสการแสดง', training_select: 'เลือกการฝึก', training_cost: '{sp} SP', training_duration: '{sec} วินาที',
  training_in_progress: 'กำลังฝึก...', training_complete: 'ฝึกเสร็จแล้ว!', training_bonus: 'ความกลัว +{pct}%',
  training_skip_ad: 'ข้าม (โฆษณา)', training_count: '{n} รอบเสร็จสิ้น', training_ghost_busy: 'ยกเลิกการมอบหมายก่อน', training_already: 'กำลังฝึกอยู่แล้ว',
  training_scream_practice: 'ฝึกกรีดร้อง', training_scream_practice_desc: 'ปรับปรุงการฉายเสียงและจังหวะ',
  training_jumpscare_acting: 'การแสดงจัมป์แสแคร์', training_jumpscare_acting_desc: 'เชี่ยวชาญศิลปะการปรากฏตัวกะทันหัน',
  training_psychological_acting: 'สยองขวัญทางจิตวิทยา', training_psychological_acting_desc: 'เรียนรู้การสร้างความหวาดกลัวยาวนาน',
  training_atmosphere_directing: 'กำกับบรรยากาศ', training_atmosphere_directing_desc: 'ควบคุมแสง เสียง และหมอก',
  training_physical_training: 'ฝึกร่างกาย', training_physical_training_desc: 'สร้างความอดทนสำหรับการหลอกหลอนที่กระฉับกระเฉง',
  training_audience_analysis: 'วิเคราะห์ผู้ชม', training_audience_analysis_desc: 'ศึกษาพฤติกรรมผู้เยี่ยมชมเพื่อความกลัวที่ดีที่สุด',

  tq_jinaeryeong_scream: 'ผีหญิงเกาหลีกำลังวิเคราะห์หนังผีบน YouTube...',
  tq_gangsi_scream: 'เจียงชีฝึกกรีดร้องในท่าแข็งทื่อ...',
  tq_vampire_scream: 'แวมไพร์ฮัมเพลงโอเปร่าในห้องใต้ดิน...',
  tq_kappa_scream: 'คัปปะกรอกเสียงร้องใต้น้ำในถัง...',
  tq_pierrot_scream: 'ตัวตลกร้องใส่ลูกโป่ง...', tq_banshee_scream: 'แบนชีสอนมาสเตอร์คลาสให้มือใหม่...',
  tq_jinaeryeong_jumpscare: 'ผีหญิงเกาหลีกระโดดออกจากตู้ซ้ำแล้วซ้ำเล่า...',
  tq_gangsi_jumpscare: 'เจียงชียืดเหยียดก่อนฝึกกระโดด...',
  tq_vampire_jumpscare: 'แวมไพร์ฝึกเปิดเสื้อคลุมอย่างดราม่า...',
  tq_kappa_jumpscare: 'คัปปะโผล่ออกจากชักโครก...', tq_pierrot_jumpscare: 'ตัวตลกซ้อมจังหวะแตกลูกโป่ง...',
  tq_banshee_jumpscare: 'แบนชีฝึกท่าเต้นการเข้าฉาก...',
  tq_jinaeryeong_psych: 'ผีหญิงเกาหลีอ่านตำราจิตวิทยา...',
  tq_gangsi_psych: 'เจียงชีพยายามทำหน้าน่ากลัว (น่ากลัวอยู่แล้ว)...',
  tq_vampire_psych: 'แวมไพร์ฝึกหน้ากระจก... (ไม่เห็นอะไรเลย)',
  tq_kappa_psych: 'คัปปะเรียนรู้ความกลัวของมนุษย์จากหนังสือห้องสมุด...',
  tq_pierrot_psych: 'ตัวตลกดู "It" รอบที่ 50...', tq_banshee_psych: 'แบนชีเขียนบทกระซิบน่าขนลุก...',
  tq_jinaeryeong_atmo: 'ผีหญิงเกาหลีจัดผมเพื่อเอฟเฟกต์สูงสุด...',
  tq_gangsi_atmo: 'เจียงชีปรับค่าเครื่องสร้างหมอก...',
  tq_vampire_atmo: 'แวมไพร์เลือกมุมเทียนที่สมบูรณ์แบบ...',
  tq_kappa_atmo: 'คัปปะทดสอบเสียงหยดน้ำต่างๆ...',
  tq_pierrot_atmo: 'ตัวตลกทาสีเรืองแสงบนกำแพง...',
  tq_banshee_atmo: 'แบนชีปรับเอฟเฟกต์เสียงสะท้อนในทางเดิน...',
  tq_jinaeryeong_physical: 'ผีหญิงเกาหลีฝึกคลานบนเพดาน...',
  tq_gangsi_physical: 'เจียงชีทำสควอตขาแข็ง...',
  tq_vampire_physical: 'แวมไพร์วิดพื้นในโลงศพ...',
  tq_kappa_physical: 'คัปปะว่ายน้ำในบ่อ...',
  tq_pierrot_physical: 'ตัวตลกซิทอัพพร้อมกับเล่นกล...',
  tq_banshee_physical: 'แบนชีอุ่นเสียงสายเสียง...',
  tq_jinaeryeong_audience: 'ผีหญิงเกาหลีอ่านรีวิวผู้เยี่ยมชมออนไลน์...',
  tq_gangsi_audience: 'เจียงชีศึกษารูปแบบการเดินของผู้เยี่ยมชม...',
  tq_vampire_audience: 'แวมไพร์วิเคราะห์ข้อมูลประชากรความกลัว...',
  tq_kappa_audience: 'คัปปะสำรวจว่าวัยไหนกลัวน้ำ...',
  tq_pierrot_audience: 'ตัวตลกติดตามสถิติโรคกลัวตัวตลก...',
  tq_banshee_audience: 'แบนชีศึกษาการตอบสนองต่อความถี่เสียง...',

  props_title: 'ของตกแต่งห้อง', prop_buy: 'ซื้อ ({sp} SP)', prop_upgrade: 'อัปเกรด ({sp} SP)', prop_max: 'สูงสุด', prop_level: 'Lv.{n}', prop_bonus: '+{pct}% ความกลัว',
  prop_cobwebs: 'ใยแมงมุม', prop_cobwebs_desc: 'บรรยากาศน่าขนลุกคลาสสิก',
  prop_candles: 'เทียนริบหรี่', prop_candles_desc: 'เงาเต้นรำน่าขนลุก',
  prop_blood_pool: 'แอ่งเลือด', prop_blood_pool_desc: 'ของตกแต่งพื้นน่าสยดสยอง',
  prop_skull_decor: 'ตกแต่งกะโหลก', prop_skull_decor_desc: 'จัดแสดงสุดสยอง',
  prop_fog_machine: 'เครื่องสร้างหมอก', prop_fog_machine_desc: 'หมอกหนาลึกลับ',
  prop_creaky_floor: 'พื้นเสียงดัง', prop_creaky_floor_desc: 'ทุกก้าวมีเสียง',
  prop_eerie_painting: 'ภาพวาดน่าขนลุก', prop_eerie_painting_desc: 'สายตาที่ตามคุณ',
  prop_chains: 'โซ่กระทบ', prop_chains_desc: 'เสียงโลหะน่าขนลุก',

  // Staging Equipment
  prop_dry_ice: 'เครื่องน้ำแข็งแห้ง', prop_dry_ice_desc: 'สร้างหมอกหนาบนพื้นเพื่อบรรยากาศสยองขวัญ',
  prop_scent_sprayer: 'เครื่องพ่นกลิ่น', prop_scent_sprayer_desc: 'ปล่อยกลิ่นน่าสะพรึงเพื่อความสมจริง',
  prop_strobe_light: 'ไฟสโตรบ', prop_strobe_light_desc: 'แสงกะพริบทำให้ผู้เยี่ยมชมสับสน',
  prop_surround_speaker: 'ลำโพงเซอร์ราวด์', prop_surround_speaker_desc: 'เสียงรอบทิศทางสำหรับเอฟเฟกต์น่าสะพรึง',
  prop_vibration_floor: 'แผ่นพื้นสั่นสะเทือน', prop_vibration_floor_desc: 'การสั่นกะทันหันใต้เท้า',
  prop_temp_controller: 'ตัวควบคุมอุณหภูมิ', prop_temp_controller_desc: 'ลมเย็นจัดเพื่อความหวาดกลัวทางจิตใจ',
  prop_hologram_device: 'อุปกรณ์โฮโลแกรม', prop_hologram_device_desc: 'ฉายภาพลวงตาผีในห้อง',
  prop_auto_lock: 'ล็อคประตูอัตโนมัติ', prop_auto_lock_desc: 'ประตูปิดกะทันหันหลังผู้เยี่ยมชม',
  props_category_decoration: 'อุปกรณ์ตกแต่ง', props_category_staging: 'อุปกรณ์การแสดง',
  props_staging_desc: 'อุปกรณ์ขั้นสูงสำหรับเอฟเฟกต์สยองขวัญระดับมืออาชีพ',

  facilities_title: 'สิ่งอำนวยความสะดวก', facility_build: 'สร้าง ({sp} SP)', facility_upgrade: 'อัปเกรด ({sp} SP)',
  facility_level: 'Lv.{n}', facility_built: 'สร้างแล้ว',
  facility_haunted_house: 'บ้านผีสิง', facility_haunted_house_desc: 'อาคารหลักประสบการณ์สยองขวัญ',
  facility_haunted_house_bonus: 'ทางเข้าอาคารหลัก', facility_enter: 'เข้า',
  facility_ticket_booth: 'จุดขายตั๋ว', facility_ticket_booth_desc: 'ขายตั๋วเข้าชมให้ผู้เยี่ยมชม', facility_ticket_booth_bonus: 'เพิ่มจำนวนผู้เยี่ยมชมสูงสุด', facility_ticket_booth_visitors: 'คน',
  facility_gift_shop: 'ร้านของที่ระลึก', facility_gift_shop_desc: 'ขายของที่ระลึกบ้านผีสิง',
  facility_gift_shop_bonus: '+{sp} SP ต่อกลุ่มผู้เยี่ยมชม',
  facility_snack_bar: 'ร้านขนม', facility_snack_bar_desc: 'ขนมและเครื่องดื่มน่ากลัว',
  facility_snack_bar_bonus: '+{pct}% รางวัลผู้เยี่ยมชม',
  facility_photo_booth: 'บูธถ่ายรูป', facility_photo_booth_desc: 'สถานีเซลฟี่สยองขวัญ',
  facility_photo_booth_bonus: '+{sp} SP ต่อกลุ่มผู้เยี่ยมชม',

  reviews_title: 'รีวิวผู้เยี่ยมชม', reviews_empty: 'ยังไม่มีรีวิว รอผู้เยี่ยมชม!',
  reviews_fame_bonus: '+{n} ชื่อเสียง', review_stars: '{n} ดาว', reviews_avg: 'เฉลี่ย: {n} ดาว',
  review_5_1: 'น่ากลัวจริงๆ! โดยเฉพาะ {ghost} ชั้น 3 สุดยอด!',
  review_5_2: 'บ้านผีสิงดีที่สุด! ร้องจนเสียงแหบ!',
  review_5_3: 'การแสดงของ {ghost} คู่ควรออสการ์! 10 เต็ม 10!',
  review_5_4: 'วิญญาณเกือบหลุด คุ้มค่าทุกบาท!',
  review_4_1: '{ghost} น่ากลัวดี แต่คาดหวังมากกว่าจากชั้นบน',
  review_4_2: 'บรรยากาศเยี่ยม! เกือบฉี่ราด เกือบ.',
  review_4_3: '{ghost} น่าประทับใจแต่จังหวะอาจดีกว่านี้',
  review_4_4: 'น่ากลัวตลอด แนะนำเพื่อน!',
  review_3_1: 'ก็ได้ ห้องว่างทำให้เสียบรรยากาศ',
  review_3_2: '{ghost} ดูเหนื่อยวันนี้ พักบ้างนะ?',
  review_3_3: 'ประสบการณ์ธรรมดา ต้องการของตกแต่งเพิ่ม',
  review_2_1: '{ghost} หลับตอนทำงาน ขอคืนเงิน',
  review_2_2: 'ตลกมากกว่าน่ากลัว ผีต้องไปเรียนการแสดง',
  review_2_3: '{ghost} พยายามแล้ว แต่...ไม่น่ากลัวเลย',
  review_1_1: 'ห้องว่างเต็มไปหมด เปิดอยู่หรือเปล่า?',
  review_1_2: 'ขอเงินคืน คุณยายฉันน่ากลัวกว่า',
  review_1_3: '{ghost} โบกมือให้ฉัน โบกมือ นั่นไม่ใช่วิธีหลอกหลอน',

  review_street_5star: 'สวนสนุกทั้งหมดยอดเยี่ยม! บ้านผีสิงน่ากลัวมาก!', review_street_4star: 'ประสบการณ์ดี บ้านผีสิงน่ากลัว ของกินอร่อย', review_street_3star: 'ก็ได้ บ้านผีสิงควรมีผีเพิ่ม', review_street_2star: 'ไม่มีอะไรทำ บ้านผีสิงก็เฉยๆ', review_street_1star: 'เสียเวลา ไม่น่ากลัวเลย',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',
  ad_sp_boost: 'SP 2 เท่า (30 วินาที)', ad_sp_boost_desc: 'เพิ่ม SP เป็น 2 เท่าเป็นเวลา 30 วินาที',
  ad_recover_fatigue: 'ฟื้นฟูฟรี', ad_recover_fatigue_desc: 'ฟื้นฟูความเมื่อยล้าผีฟรี',
  ad_vip_visitor: 'ผู้เยี่ยมชม VIP', ad_vip_visitor_desc: 'เรียกกลุ่มผู้เยี่ยมชมรางวัลสูง',
  ad_skip_training: 'ข้ามการฝึก', ad_skip_training_desc: 'ฝึกเสร็จทันที',
  ad_active_boost: 'SP 2 เท่าเปิดอยู่!', ad_rewards_title: 'รางวัลโฆษณา',

  // === Business / Open-Close System ===
  day_label: 'วันที่ {n}',
  hud_operation_day: 'วันที่ {n}',
  status_open: 'เปิด',
  status_closed: 'ปิด',
  manage_business: 'Manage Business',
  toggle_open: 'เปิดทำการ',
  toggle_close: 'ปิดทำการ',
  facility_open_badge: 'เปิดแล้ว',
  need_ghost_to_open: 'ต้องวางผีในห้องก่อน!',
  ticket_price: 'ราคาตั๋ว',
  ticket_price_label: '{n} SP',
  ticket_price_low: 'ผู้เยี่ยมชมมาก รายได้ต่อคนน้อย',
  ticket_price_high: 'ผู้เยี่ยมชมน้อย รายได้ต่อคนมาก',
  end_day: 'สิ้นสุดวัน',
  day_summary_title: 'สรุปวันที่ {n}',
  day_summary_visitors: 'ผู้เยี่ยมชม: {n}',
  day_summary_earnings: 'รายได้: {n} SP',
  day_summary_avg_rating: 'คะแนนเฉลี่ย: {n}',
  day_summary_next: 'จบวันและรับรางวัล',
  day_summary_best_visitor: 'ผู้เยี่ยมชม {n} ดาว!',
  day_summary_sp_collected: 'SP รวมที่เก็บได้',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: 'เป้าหมายประจำวัน',
  day_summary_total_visits: 'การเยี่ยมชมทั้งหมด',
  day_summary_reaction_5: 'น่ากลัวมาก!',
  day_summary_reaction_4: 'หลอนมาก!',
  day_summary_reaction_3: 'ไม่เลว',
  day_summary_reaction_2: 'งั้นๆ...',
  day_summary_reaction_1: 'น่าเบื่อ...',

  milestone_visitors_5: 'ต้อนรับผู้เยี่ยมชม {target} คน',
  milestone_visitors_10: 'ต้อนรับผู้เยี่ยมชม {target} คน',
  milestone_visitors_20: 'ต้อนรับผู้เยี่ยมชม {target} คน',
  milestone_earnings_1000: 'หาเงิน {target} SP',
  milestone_earnings_5000: 'หาเงิน {target} SP',
  milestone_earnings_10000: 'หาเงิน {target} SP',
  milestone_flee_0: 'ไม่มีผู้หนี',
  milestone_flee_1: 'ผู้หนีไม่เกิน {target} คน',
  milestone_rooms_3: 'เปิดห้อง {target}+ ห้อง',
  milestone_rooms_5: 'เปิดห้อง {target}+ ห้อง',
  milestone_ghosts_2: 'วางผี {target}+ ตัว',
  milestone_ghosts_3: 'วางผี {target}+ ตัว',
  milestone_reward: '+{n} SP',

  reviews_panel_title: 'รีวิวผู้เยี่ยมชม',
  reviews_panel_avg: 'คะแนนเฉลี่ย',
  reviews_panel_empty: 'ยังไม่มีรีวิว',

  // --- Missing keys (English fallback) ---
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  view_building: 'อาคาร',
  view_other_buildings: '< อาคารอื่น',
  view_lobby: 'ล็อบบี้',
  view_facilities: 'สิ่งอำนวยความสะดวก',
  view_academy: 'สถาบัน',
  lobby_title: 'ล็อบบี้',
  lobby_queue: 'คิวรอ',
  lobby_queue_empty: 'ไม่มีผู้เยี่ยมชมรอ',
  lobby_active_teams: 'กำลังสำรวจ: {cur}/{max} ทีม',
  lobby_wait_time: 'รอ: {n} วินาที',
  lobby_team_size: '{n} คน',
  lobby_staff: 'พนักงานล็อบบี้',
  lobby_staff_empty: 'ไม่มีพนักงาน',
  lobby_assign_staff: 'มอบหมายพนักงาน',
  lobby_unassign_staff: 'ถอน',
  lobby_staff_effect: 'ลดเวลารอ เพิ่มความพึงพอใจ',
  lobby_ticket_booth: 'ช่องขายตั๋ว',
  facilities_view_title: 'จัดการสิ่งอำนวยความสะดวก',
  facilities_view_empty: 'ยังไม่มีสิ่งอำนวยความสะดวก สร้างในเมนู!',
  facility_staff: 'พนักงาน',
  facility_staff_none: 'ไม่มีพนักงาน',
  facility_assign_staff: 'มอบหมายพนักงาน',
  facility_unassign_staff: 'ถอนพนักงาน',
  facility_staff_bonus: 'พนักงานช่วยเพิ่มคุณภาพบริการ',
  facility_restroom: 'ห้องน้ำ',
  facility_restroom_desc: 'ป้องกันการลดความพึงพอใจ',
  facility_restroom_bonus: 'ไม่มีบทลงโทษเมื่อสร้าง',
  facility_parking_lot: 'ที่จอดรถ',
  facility_parking_lot_desc: 'เพิ่มอัตราการมาของผู้เยี่ยมชม',
  facility_parking_lot_bonus: '+{pct}% อัตราผู้เยี่ยมชมต่อเลเวล',
  facility_first_aid: 'ห้องปฐมพยาบาล',
  facility_first_aid_desc: 'ดูแลผู้เยี่ยมชมที่หนี/เป็นลม',
  facility_first_aid_bonus: 'ป้องกันรีวิวแย่จากการหนี',
  facility_arcade: 'อาร์เคด',
  facility_arcade_desc: 'มินิเกมและแอทแทรกชั่นสยอง',
  facility_arcade_bonus: 'เพิ่มความตื่นเต้นผู้เยี่ยมชม',
  facility_fortune_teller: 'หมอดู',
  facility_fortune_teller_desc: 'ไพ่ทาโร่และอ่านลายมือ',
  facility_fortune_teller_bonus: 'เพิ่มความพึงพอใจ',
  facility_escape_room: 'ห้องหนีภัย',
  facility_escape_room_desc: 'ท้าทายปริศนาสยองจับเวลา',
  facility_escape_room_bonus: 'รายได้สูงต่อผู้เยี่ยมชม',
  facility_stage: 'เวที',
  facility_stage_desc: 'โชว์และการแสดงผี',
  facility_stage_bonus: 'เพิ่มชื่อเสียงสวนสนุก',
  facility_voodoo_shop: 'ร้านวูดู',
  facility_voodoo_shop_desc: 'เครื่องรางต้องคำสาปและของวิเศษ',
  facility_voodoo_shop_bonus: 'เพิ่มอัตราดรอปไอเทมพิเศษ',
  facility_ghost_cafe: 'คาเฟ่ผี',
  facility_ghost_cafe_desc: 'เครื่องดื่มลึกลับจากผี',
  facility_ghost_cafe_bonus: 'ผู้เยี่ยมชมอยู่นานขึ้น',
  facility_phantom_cinema: 'โรงหนังผี',
  facility_phantom_cinema_desc: 'ฉายหนังสยองขวัญเหนือธรรมชาติ',
  facility_phantom_cinema_bonus: 'รายได้ตั๋วสูง',
  facility_skeleton_spa: 'สปาโครงกระดูก',
  facility_skeleton_spa_desc: 'ผ่อนคลายถึงกระดูก',
  facility_skeleton_spa_bonus: 'ฟื้นฟูความเหนื่อยล้าเร็วขึ้น',
  academy_title: 'สถาบันผี',
  academy_empty: 'จ้างผีก่อนเริ่มฝึก!',
  academy_select_ghost: 'เลือกผีที่จะฝึก',
  academy_select_training: 'เลือกหลักสูตรฝึกอบรม',
  academy_skill_level: 'Lv.{n}/{max}',
  academy_skill_maxed: 'เชี่ยวชาญ',
  academy_training_time: '{sec} วินาที',
  academy_training_cost: '{sp} SP',
  academy_in_progress: 'กำลังฝึก...',
  academy_complete: 'เสร็จสิ้น!',
  academy_skip_ad: 'ข้าม (โฆษณา)',
  academy_ghost_busy: 'ผีกำลังยุ่ง',
  academy_acting: 'คลาสการแสดง',
  academy_acting_desc: 'ปรับปรุงการแสดงและจังหวะการหลอก',
  academy_acting_effect: 'เอฟเฟกต์หลอก +20% ต่อเลเวล',
  academy_human_relations: 'มนุษยสัมพันธ์',
  academy_human_relations_desc: 'เรียนรู้ที่จะเข้าใจผู้เยี่ยมชม',
  academy_human_relations_effect: 'ความพึงพอใจ +15% ต่อเลเวล',
  academy_psychology: 'จิตวิทยา',
  academy_psychology_desc: 'เจาะจุดอ่อนผู้เยี่ยมชม',
  academy_psychology_effect: 'โบนัสจุดอ่อนต่อเลเวล',
  academy_special_fx: 'เทคนิคพิเศษ',
  academy_special_fx_desc: 'เชี่ยวชาญการใช้อุปกรณ์และเอฟเฟกต์',
  academy_special_fx_effect: 'โบนัสอุปกรณ์ x2 ต่อเลเวล',
  academy_fitness: 'ฝึกร่างกาย',
  academy_fitness_desc: 'เพิ่มความอดทนและความแข็งแรง',
  academy_fitness_effect: 'การฟื้นตัวจากเหนื่อยล้า +50% ต่อเลเวล',
  academy_teamwork: 'การทำงานเป็นทีม',
  academy_teamwork_desc: 'ประสานงานกับผีใกล้เคียง',
  academy_teamwork_effect: 'หลอกแบบลูกโซ่ +30% ต่อเลเวล',
  academy_customer_service: 'บริการลูกค้า',
  academy_customer_service_desc: 'ปรับปรุงบริการล็อบบี้/สิ่งอำนวยความสะดวก',
  academy_customer_service_effect: 'คุณภาพบริการเพิ่มต่อเลเวล',
  facility_detail_income: 'รายได้',
  facility_detail_sp_per_group: '{n} SP / กลุ่ม',
  facility_detail_bonus: 'โบนัส',
  facility_detail_upgrade: 'อัปเกรด ({sp} SP)',
  facility_detail_assign: 'มอบหมายพนักงาน',
  facility_detail_status_active: 'กำลังดำเนินการ',
  facility_detail_status_buildable: 'สร้างได้',
  facility_detail_status_locked: 'ล็อค',
  facility_detail_no_income: 'ไม่มีรายได้โดยตรง',
  ghost_role_scare: 'หน้าที่หลอก',
  ghost_role_lobby_staff: 'พนักงานล็อบบี้',
  ghost_role_facility_staff: 'พนักงานสิ่งอำนวยความสะดวก',
  ghost_role_instructor: 'ผู้ฝึกสอน',
  shop_pro_ghosts: 'Professional Ghosts',
  pro_ghost_badge: 'PRO',
  ghost_grim_reaper: 'Grim Reaper',
  ghost_origin_underworld: 'Underworld',
  ghost_grim_reaper_skill: 'Soul Harvest: All fear types S-rank, absolute terror',
  ghost_grim_reaper_quote: 'Your time has come... just kidding. Or am I?',
  ghost_grim_reaper_fatigued: 'Even death needs a vacation sometimes...',
  ghost_grim_reaper_unique: 'Instant max fear on any visitor type',
  ghost_blood_count: 'Blood Count',
  ghost_origin_transylvania: 'Transylvania',
  ghost_blood_count_skill: 'Blood Charm: Charisma-based visual + psychological S-rank',
  ghost_blood_count_quote: 'I do not drink... wine.',
  ghost_blood_count_fatigued: 'The sun... it burns... need coffin...',
  ghost_blood_count_unique: 'Charm aura: adjacent rooms get +20% scare',
  ghost_well_spirit: 'Well Spirit',
  ghost_well_spirit_skill: 'Well Crawl: Psychological horror S-rank, lingering dread',
  ghost_well_spirit_quote: '...seven days...',
  ghost_well_spirit_fatigued: 'My hair is so tangled... need conditioner...',
  ghost_well_spirit_unique: 'Lingering fear: visitors stay scared in next room',
  ghost_nightmare_specter: 'Nightmare Specter',
  ghost_origin_dreamworld: 'Dream World',
  ghost_nightmare_specter_skill: 'Nightmare Slash: Physical + psychological S-rank dream terror',
  ghost_nightmare_specter_quote: 'Sweet dreams... or not.',
  ghost_nightmare_specter_fatigued: 'Even nightmares need beauty sleep...',
  ghost_nightmare_specter_unique: 'Dream invasion: double scare on sleeping visitors',
  ghost_shadow_stalker: 'Shadow Stalker',
  ghost_origin_void: 'The Void',
  ghost_shadow_stalker_skill: 'Static Presence: Psychological horror max, stalker-type',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: 'Static aura: all visitors on floor get +15% fear',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  lobby_room_ticket_booth: 'จุดขายตั๋ว',
  lobby_room_ticket_booth_desc: 'ที่ที่ผู้เข้าชมซื้อตั๋ว',
  lobby_room_ticket_booth_effect: 'ความเร็วขายตั๋วพื้นฐาน',
  lobby_room_waiting_lounge: 'ห้องรอ',
  lobby_room_waiting_lounge_desc: 'พื้นที่รอที่สะดวกสบายพร้อมที่นั่ง',
  lobby_room_waiting_lounge_effect: 'ความอดทนผู้เข้าชม +20% ต่อเลเวล',
  lobby_room_vip_lounge: 'ห้อง VIP',
  lobby_room_vip_lounge_desc: 'ห้องรอพรีเมียมสำหรับ VIP',
  lobby_room_vip_lounge_effect: 'ผู้เข้าชม VIP ใช้จ่าย SP 2 เท่า',
  lobby_room_reservation_center: 'ศูนย์จอง',
  lobby_room_reservation_center_desc: 'ระบบจองล่วงหน้าสำหรับผู้เข้าชม',
  lobby_room_reservation_center_effect: 'อัตราผู้เข้าชม +15% ต่อเลเวล',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: 'เลือกสิ่งอำนวยความสะดวก...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: 'สร้างสิ่งอำนวยความสะดวก',
  lobby_select_facility: 'เลือกสิ่งอำนวยความสะดวก',
  lobby_props_count: '{n} อุปกรณ์',
  lobby_props_title: 'วัตถุ',
  lobby_tab_info: 'ข้อมูล',
  lobby_tab_objects: 'วัตถุ',
  lobby_tab_upgrade: 'อัปเกรด',
  lobby_tab_demolish: 'รื้อถอน',
  lobby_demolish_confirm: 'ลบสิ่งอำนวยความสะดวกนี้? ชั้นจะยังคงอยู่แต่จะว่างเปล่า',
  lobby_demolish_btn: 'รื้อถอนสิ่งอำนวยความสะดวก',
  lobby_no_ghost: 'ไม่มีพนักงาน',
  lobby_upgrade_max: 'เลเวลสูงสุด',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: 'ผลหลังอัปเกรด:',
  facility_build_floor: 'สร้าง',

  facility_map_title: 'พื้นที่สิ่งอำนวยความสะดวก',
  facility_build_here: 'สร้าง',
  facility_select_to_build: 'เลือกสิ่งอำนวยความสะดวก',
  facility_all_built: 'สิ่งอำนวยความสะดวกทั้งหมดถูกสร้างแล้ว',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: 'ปลดล็อกพื้นที่',
  facility_unlock_plot_desc: 'ปลดล็อกพื้นที่นี้ด้วย {sp} SP เพื่อสร้างสิ่งอำนวยความสะดวกใหม่',
  facility_unlock_plot_btn: 'ปลดล็อก ({sp} SP)',
  facility_build_popup_title: 'สร้างสิ่งอำนวยความสะดวก',
  facility_build_action: 'สร้าง',
  facility_select_theme: 'เลือกธีม',
  facility_upgrade_preview: 'ผลอัปเกรด',
  facility_upgrade_revenue: 'รายได้ต่อกลุ่ม',
  facility_upgrade_bonus: 'โบนัสรายได้',
  facility_upgrade_capacity: 'ความจุ',
  facility_upgrade_current: 'ปัจจุบัน',
  facility_upgrade_next: 'ถัดไป',
  facility_upgrade_max_level: 'ระดับสูงสุดแล้ว',
  facility_revenue: 'รายได้',
  facility_total_revenue: 'รายได้รวม',
  facility_hourly_revenue: 'ต่อกลุ่ม',
  facility_set_price: 'ตั้งราคา',
  facility_price_hint_high: 'ราคาสูง: กำไรเพิ่ม ผู้เข้าชมลด',
  facility_price_hint_low: 'ราคาต่ำ: ผู้เข้าชมเพิ่ม กำไรลด',
  facility_price_hint_free: 'เข้าฟรี',
  facility_price_hint_normal: 'ราคาสมดุล',
  facility_open: 'เปิด',
  facility_close: 'ปิด',
  facility_closed_badge: 'ปิดอยู่',
  facility_needs_staff: 'มอบหมายพนักงานเพื่อเปิด',
  facility_demolish: 'รื้อถอน',
  facility_demolish_confirm: 'รื้อถอน {name}? ไม่สามารถย้อนกลับได้',
  facility_move: 'ย้าย',
  facility_move_select: 'เลือกพื้นที่ว่างเพื่อย้าย',
  facility_move_no_empty: 'ไม่มีพื้นที่ว่าง',

  lobby_prop_sofa: 'โซฟา',
  lobby_prop_sofa_desc: 'ที่นั่งสบายสำหรับผู้รอ',
  lobby_prop_tv_screen: 'จอทีวี',
  lobby_prop_tv_screen_desc: 'ความบันเทิงระหว่างรอ',
  lobby_prop_vending_machine: 'ตู้ขายของอัตโนมัติ',
  lobby_prop_vending_machine_desc: 'ขนมและเครื่องดื่มสำหรับผู้เข้าชม',
  lobby_prop_info_sign: 'ป้ายข้อมูล',
  lobby_prop_info_sign_desc: 'นำทางผู้เข้าชม',
  lobby_prop_potted_plant: 'กระถางต้นไม้',
  lobby_prop_potted_plant_desc: 'เพิ่มความเขียวชอุ่มน่าขนลุก',
  lobby_prop_umbrella_stand: 'ที่วางร่ม',
  lobby_prop_umbrella_stand_desc: 'ที่เก็บร่มเปียก',

  fac_prop_display_shelf: 'ชั้นวาง',
  fac_prop_display_shelf_desc: 'แสดงสินค้าอย่างน่าสนใจ',
  fac_prop_cash_register: 'เครื่องเก็บเงิน',
  fac_prop_cash_register_desc: 'เร่งการทำธุรกรรม',
  fac_prop_coffee_machine: 'เครื่องชงกาแฟ',
  fac_prop_coffee_machine_desc: 'เสิร์ฟเครื่องดื่มร้อน',
  fac_prop_menu_board: 'บอร์ดเมนู',
  fac_prop_menu_board_desc: 'แสดงตัวเลือกอาหาร',
  fac_prop_camera_light: 'ไฟกล้อง',
  fac_prop_camera_light_desc: 'แสงสว่างสำหรับถ่ายภาพ',
  fac_prop_backdrop: 'ฉากหลัง',
  fac_prop_backdrop_desc: 'ฉากถ่ายรูปธีม',
  fac_prop_hand_dryer: 'เครื่องเป่ามือ',
  fac_prop_hand_dryer_desc: 'รักษาความสะอาดแห้ง',
  fac_prop_mirror: 'กระจก',
  fac_prop_mirror_desc: 'อุปกรณ์ห้องน้ำน่ากลัว',
  fac_prop_parking_sign: 'ป้ายที่จอดรถ',
  fac_prop_parking_sign_desc: 'นำทางไปที่จอดรถ',
  fac_prop_barrier_gate: 'แผงกั้น',
  fac_prop_barrier_gate_desc: 'ระบบจอดรถอัตโนมัติ',
  fac_prop_first_aid_kit: 'กล่องปฐมพยาบาล',
  fac_prop_first_aid_kit_desc: 'อุปกรณ์ทางการแพทย์พื้นฐาน',
  fac_prop_stretcher: 'เปลหาม',
  fac_prop_stretcher_desc: 'สำหรับผู้เข้าชมที่เป็นลม',

  tab_facilities: 'สิ่งอำนวยความสะดวก',
  tab_hire: 'จ้างงาน',
  tab_staff: 'พนักงาน',
  tab_support_facilities: 'สิ่งอำนวยความสะดวก',
  tab_achievements: 'ความสำเร็จ',
  achievements_title: 'ความสำเร็จ',
  achievements_coming_soon: 'เร็วๆ นี้...',
  facilities_mgmt_title: 'จัดการสิ่งอำนวยความสะดวก',
  facility_condition: 'สภาพ',
  facility_hygiene: 'สุขอนามัย',
  facility_condition_warning: 'ต้องการซ่อมแซม!',
  facility_hygiene_warning: 'ต้องการทำความสะอาด!',
  dispatch_repair: 'ส่งช่างซ่อม',
  dispatch_clean: 'ส่งแม่บ้าน',
  no_repair_staff: 'ไม่มีช่างซ่อม',
  no_janitor_staff: 'ไม่มีแม่บ้าน',
  repair_dispatched: 'ส่งช่างซ่อมแล้ว',
  clean_dispatched: 'ส่งแม่บ้านแล้ว',
  ticket_section_title: 'ราคาตั๋ว',
  expected_visitors: 'ผู้เยี่ยมชมที่คาดหวัง: ~{n}/วัน',
  star_rating_title: 'คะแนนจากผู้เยี่ยมชม',
  star_level_gray: 'ดาวเทา',
  star_level_bronze: 'ดาวทองแดง',
  star_level_silver: 'ดาวเงิน',
  star_level_gold: 'ดาวทอง',
  star_level_rainbow: 'ดาวสายรุ้ง',
  star_evolution_max: 'บ้านผีสิงที่ดีที่สุด',
  star_current: '{cur}/{max}',
  hire_title: 'จ้างพนักงาน',
  hire_scare_section: 'ผู้เชี่ยวชาญหลอกหลอน',
  hire_staff_section: 'พนักงานสิ่งอำนวยความสะดวก',
  staff_role_repair: 'ช่างซ่อม',
  staff_role_janitor: 'แม่บ้าน',
  staff_role_ticket: 'พนักงานขายตั๋ว',
  staff_role_guide: 'ไกด์',
  staff_role_repair_desc: 'ซ่อมแซมสิ่งอำนวยความสะดวก',
  staff_role_janitor_desc: 'ดูแลสุขอนามัย',
  staff_role_ticket_desc: 'ดำเนินงานล็อบบี้',
  staff_role_guide_desc: 'โบนัสความพึงพอใจ',
  hire_cost_label: '{sp} SP',
  staff_title: 'รายชื่อพนักงาน',
  staff_empty: 'ยังไม่มีพนักงาน',
  staff_detail_title: 'รายละเอียดพนักงาน',
  staff_detail_type: 'ประเภท',
  staff_detail_role: 'บทบาท',
  staff_detail_grade: 'เกรด',
  staff_detail_skills: 'ทักษะ',
  staff_detail_assigned: 'มอบหมายที่',
  staff_detail_not_assigned: 'ยังไม่มอบหมาย',
  staff_detail_hired_days: 'วันจ้าง: วันที่ {n}',
  staff_detail_praise: 'คำชม: {n}',
  skill_acting: 'การแสดง',
  skill_friendliness: 'ความเป็นมิตร',
  skill_psychology: 'จิตวิทยา',
  skill_special_fx: 'เอฟเฟกต์พิเศษ',
  skill_fitness: 'สมรรถภาพ',
  skill_teamwork: 'การทำงานเป็นทีม',
  skill_service: 'การบริการ',
  room_detail_tab_info: 'ข้อมูลห้อง',
  room_detail_tab_props: 'สิ่งอำนวยความสะดวก',
  room_detail_tab_upgrade: 'อัปเกรด',
  room_detail_tab_demolish: 'รื้อถอน',
  room_detail_ghost_none: 'ยังไม่มอบหมาย',
  room_detail_condition: 'ความทนทาน',
  room_detail_hygiene: 'ความสะอาด',
  room_detail_request_repair: 'ขอซ่อม ({sp} SP)',
  room_detail_request_cleaning: 'ขอทำความสะอาด ({sp} SP)',
  room_detail_repairing: 'กำลังซ่อม... {sec}วิ',
  room_detail_cleaning: 'กำลังทำความสะอาด... {sec}วิ',
  room_detail_collapsed: 'พังทลาย',
  room_detail_collapsed_desc: 'ห้องพังทลายแล้ว ซ่อมเพื่อกู้คืน',
  room_detail_condition_ok: 'สภาพดี',
  room_detail_hygiene_ok: 'ความสะอาดดี',
  room_upgrade_structure: 'เสริมโครงสร้าง',
  room_upgrade_structure_desc: 'ลดการเสื่อมสภาพต่อการเยี่ยมชม',
  room_upgrade_structure_effect: '-{pct}% การลดสภาพต่อเลเวล',
  room_upgrade_structure_bonus_10: 'ห้องแข็งแกร่ง: ค่าซ่อม -30%',
  room_upgrade_structure_bonus_20: 'ห้องอมตะ: สภาพขั้นต่ำ 50',
  room_upgrade_purify: 'การชำระล้างอัตโนมัติ',
  room_upgrade_purify_desc: 'ลดการสูญเสียความสะอาดต่อการเยี่ยมชม',
  room_upgrade_purify_effect: '-{pct}% การลดความสะอาดต่อเลเวล',
  room_upgrade_purify_bonus_10: 'ห้องหอม: ความพึงพอใจ +10%',
  room_upgrade_purify_bonus_20: 'เวทมนตร์ทำความสะอาด: ฟื้นฟูอัตโนมัติ',
  room_upgrade_level: 'Lv.{cur}/{max}',
  room_upgrade_cost: 'อัปเกรด ({sp} SP)',
  room_upgrade_max: 'สูงสุด',
  room_upgrade_bonus_unlocked: 'ปลดล็อกแล้ว!',
  room_upgrade_bonus_locked: 'โบนัส Lv.{n}',
  room_demolish_warning: 'การรื้อห้องนี้จะทำลายสิ่งอำนวยความสะดวกและอัปเกรดทั้งหมด',
  room_demolish_cost: 'ค่าใช้จ่าย: ฟรี',
  room_demolish_btn: 'รื้อถอน',
  room_demolish_confirm: 'แน่ใจหรือว่าต้องการรื้อห้องนี้? ไม่สามารถย้อนกลับได้',
  room_props_installed: 'อุปกรณ์ที่ติดตั้ง',
  room_props_available: 'อุปกรณ์ที่มี',
  room_props_none: 'ยังไม่มีอุปกรณ์',
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: 'ภาษา',
  menu_reset: 'รีเซ็ตเกม',
  menu_reset_confirm: 'แน่ใจหรือ? ไม่สามารถย้อนกลับได้',
  menu_info: 'ข้อมูลเกม',
  menu_version: 'เวอร์ชัน {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: 'ความกลัว',
  stat_thrill: 'ความตื่นเต้น',
  stat_atmosphere: 'บรรยากาศ',
  stat_fun: 'ความสนุก',
  stat_total: 'สถิติห้อง',
  room_grade: 'เกรด',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  phase_day: '\u0E40\u0E15\u0E23\u0E35\u0E22\u0E21',
  phase_evening: '\u0E40\u0E1B\u0E34\u0E14',
  phase_night: '\u0E1B\u0E34\u0E14',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}\u0E27\u0E34',
  phase_day_hint: '\u0E40\u0E15\u0E23\u0E35\u0E22\u0E21\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E35! \u0E0B\u0E48\u0E2D\u0E21, \u0E27\u0E32\u0E07\u0E1C\u0E35, \u0E2D\u0E31\u0E1E\u0E40\u0E01\u0E23\u0E14',
  phase_evening_hint: '\u0E40\u0E27\u0E25\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E23\u0E49\u0E32\u0E19! \u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E32',
  open_now_btn: '\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E25\u0E22',
  speed_btn: 'x{n}',
  day_auto_open_hint: '\u0E16\u0E36\u0E07\u0E40\u0E27\u0E25\u0E32\u0E40\u0E22\u0E47\u0E19\u0E41\u0E25\u0E49\u0E27! \u0E40\u0E1B\u0E34\u0E14\u0E23\u0E49\u0E32\u0E19\u0E40\u0E25\u0E22',
  evening_ending_hint: '\u0E40\u0E27\u0E25\u0E32\u0E1B\u0E34\u0E14\u0E23\u0E49\u0E32\u0E19! \u0E01\u0E33\u0E25\u0E31\u0E07\u0E1B\u0E34\u0E14...',
  floor1_blocked_warning: '\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32! \u0E0B\u0E48\u0E2D\u0E21\u0E0A\u0E31\u0E49\u0E19 1!',
  gstaff_title: '\u0e1c\u0e35\u0e1e\u0e19\u0e31\u0e01\u0e07\u0e32\u0e19',
  gstaff_repairman: '\u0e1c\u0e35\u0e0a\u0e48\u0e32\u0e07\u0e0b\u0e48\u0e2d\u0e21',
  gstaff_repairman_desc: '\u0e1c\u0e35\u0e17\u0e35\u0e48\u0e17\u0e30\u0e25\u0e38\u0e1c\u0e48\u0e32\u0e19\u0e01\u0e33\u0e41\u0e1e\u0e07\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e0b\u0e48\u0e2d\u0e21\u0e2b\u0e49\u0e2d\u0e07',
  gstaff_repairman_effect: '\u0e0b\u0e48\u0e2d\u0e21\u0e2b\u0e49\u0e2d\u0e07\u0e17\u0e35\u0e48\u0e2a\u0e20\u0e32\u0e1e\u0e41\u0e22\u0e48\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34',
  gstaff_janitor: '\u0e1c\u0e35\u0e17\u0e33\u0e04\u0e27\u0e32\u0e21\u0e2a\u0e30\u0e2d\u0e32\u0e14',
  gstaff_janitor_desc: '\u0e17\u0e33\u0e04\u0e27\u0e32\u0e21\u0e2a\u0e30\u0e2d\u0e32\u0e14\u0e2b\u0e49\u0e2d\u0e07\u0e14\u0e49\u0e27\u0e22\u0e1e\u0e25\u0e31\u0e07\u0e27\u0e34\u0e0d\u0e0d\u0e32\u0e13',
  gstaff_janitor_effect: '\u0e17\u0e33\u0e04\u0e27\u0e32\u0e21\u0e2a\u0e30\u0e2d\u0e32\u0e14\u0e2b\u0e49\u0e2d\u0e07\u0e17\u0e35\u0e48\u0e2a\u0e01\u0e1b\u0e23\u0e01\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34',
  gstaff_promoter: '\u0e1c\u0e35\u0e42\u0e1b\u0e23\u0e42\u0e21\u0e17',
  gstaff_promoter_desc: '\u0e14\u0e36\u0e07\u0e14\u0e39\u0e14\u0e1c\u0e39\u0e49\u0e40\u0e22\u0e35\u0e48\u0e22\u0e21\u0e0a\u0e21\u0e14\u0e49\u0e27\u0e22\u0e40\u0e2a\u0e35\u0e22\u0e07\u0e01\u0e23\u0e30\u0e0b\u0e34\u0e1a',
  gstaff_promoter_effect: '+20% \u0e1c\u0e39\u0e49\u0e40\u0e22\u0e35\u0e48\u0e22\u0e21\u0e0a\u0e21\u0e15\u0e48\u0e2d\u0e40\u0e25\u0e40\u0e27\u0e25',
  gstaff_medic: '\u0e1c\u0e35\u0e2b\u0e21\u0e2d',
  gstaff_medic_desc: '\u0e1b\u0e25\u0e2d\u0e1a\u0e1c\u0e39\u0e49\u0e40\u0e22\u0e35\u0e48\u0e22\u0e21\u0e0a\u0e21\u0e17\u0e35\u0e48\u0e15\u0e01\u0e43\u0e08\u0e14\u0e49\u0e27\u0e22\u0e40\u0e2a\u0e19\u0e48\u0e2b\u0e4c\u0e1c\u0e35',
  gstaff_medic_effect: '\u0e1c\u0e39\u0e49\u0e40\u0e22\u0e35\u0e48\u0e22\u0e21\u0e0a\u0e21\u0e17\u0e35\u0e48\u0e2b\u0e19\u0e35\u0e43\u0e2b\u0e49\u0e23\u0e35\u0e27\u0e34\u0e27\u0e40\u0e1b\u0e47\u0e19\u0e01\u0e25\u0e32\u0e07',
  gstaff_security: '\u0e1c\u0e35\u0e22\u0e32\u0e21',
  gstaff_security_desc: '\u0e23\u0e31\u0e01\u0e29\u0e32\u0e04\u0e27\u0e32\u0e21\u0e2a\u0e07\u0e1a\u0e14\u0e49\u0e27\u0e22\u0e04\u0e27\u0e32\u0e21\u0e19\u0e48\u0e32\u0e01\u0e25\u0e31\u0e27',
  gstaff_security_effect: '+10% \u0e04\u0e27\u0e32\u0e21\u0e1e\u0e36\u0e07\u0e1e\u0e2d\u0e43\u0e08\u0e15\u0e48\u0e2d\u0e40\u0e25\u0e40\u0e27\u0e25',
  gstaff_hire_cost: '\u0e40\u0e23\u0e35\u0e22\u0e01: {sp} SP',
  gstaff_salary: '\u0e04\u0e48\u0e32\u0e14\u0e39\u0e41\u0e25: {sp} SP/\u0e27\u0e31\u0e19',
  gstaff_fire: '\u0e44\u0e25\u0e48\u0e1c\u0e35',
  gstaff_fire_confirm: '\u0e44\u0e25\u0e48\u0e1c\u0e35\u0e1e\u0e19\u0e31\u0e01\u0e07\u0e32\u0e19\u0e04\u0e19\u0e19\u0e35\u0e49?',
  gstaff_level: 'Lv.{n}',
  gstaff_none: '\u0e22\u0e31\u0e07\u0e44\u0e21\u0e48\u0e21\u0e35\u0e1c\u0e35\u0e1e\u0e19\u0e31\u0e01\u0e07\u0e32\u0e19',
  day_summary_salaries: '\u0E40\u0E07\u0E34\u0E19\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19',
  day_summary_net_earnings: '\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E2A\u0E38\u0E17\u0E18\u0E34',
  day_summary_street_visitors: '\u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21\u0E1A\u0E19\u0E16\u0E19\u0E19',
  day_summary_street_revenue: '\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01\u0E16\u0E19\u0E19',
  day_summary_reviews_title: '\u0E23\u0E35\u0E27\u0E34\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21',
  day_summary_avg_stars: '\u0E04\u0E30\u0E41\u0E19\u0E19\u0E40\u0E09\u0E25\u0E35\u0E48\u0E22',
  day_summary_fame_change: '\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07',
  day_summary_no_reviews: '\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E23\u0E35\u0E27\u0E34\u0E27\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49',
  day_summary_review_visitor: '\u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21 #{n}',
  day_summary_highlight: '\u0E44\u0E2E\u0E44\u0E25\u0E17\u0E4C',

  // === Tutorial ===
  tutorial_welcome_title: '\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E2A\u0E39\u0E48\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E35\u0E2A\u0E34\u0E07!',
  tutorial_welcome_body: '\u0E15\u0E31\u0E49\u0E07\u0E41\u0E15\u0E48\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E04\u0E38\u0E13\u0E04\u0E37\u0E2D\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E35\u0E2A\u0E34\u0E07 \u0E21\u0E32\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E35\u0E2A\u0E34\u0E07\u0E17\u0E35\u0E48\u0E2A\u0E19\u0E38\u0E01\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14\u0E01\u0E31\u0E1A\u0E1C\u0E35\u0E19\u0E49\u0E2D\u0E22\u0E46 \u0E01\u0E31\u0E19\u0E40\u0E16\u0E2D\u0E30!',
  tutorial_welcome_btn: '\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E31\u0E19!',
  tutorial_build_title: '\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E49\u0E2D\u0E07',
  tutorial_build_body: '\u0E40\u0E23\u0E34\u0E48\u0E21\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E19 \u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21 "+" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2B\u0E49\u0E2D\u0E07',
  tutorial_ghost_title: '\u0E08\u0E31\u0E14\u0E27\u0E32\u0E07\u0E1C\u0E35',
  tutorial_ghost_body: '\u0E27\u0E32\u0E07\u0E1C\u0E35\u0E43\u0E19\u0E2B\u0E49\u0E2D\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2B\u0E25\u0E2D\u0E01\u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21 \u0E41\u0E15\u0E30\u0E2B\u0E49\u0E2D\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E07\u0E1C\u0E35',
  tutorial_open_title: '\u0E40\u0E1B\u0E34\u0E14\u0E1A\u0E49\u0E32\u0E19',
  tutorial_open_body: '\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E41\u0E25\u0E49\u0E27! \u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21 "\u0E40\u0E1B\u0E34\u0E14" \u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21',
  tutorial_facility_intro_title: '\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01',
  tutorial_facility_intro_body: '\u0E2A\u0E27\u0E19\u0E2A\u0E19\u0E38\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E21\u0E35\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01! \u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E41\u0E25\u0E30\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48\u0E17\u0E48\u0E2D\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E27\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49',
  tutorial_facility_build_title: '\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01',
  tutorial_facility_build_body: '\u0E41\u0E15\u0E30\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E27\u0E48\u0E32\u0E07\u0E41\u0E25\u0E30\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01 \u0E25\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E23\u0E30\u0E25\u0E36\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E41\u0E19\u0E47\u0E01\u0E1A\u0E32\u0E23\u0E4C!',
  tutorial_facility_staff_title: '\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19',
  tutorial_facility_staff_body: '\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E1C\u0E35\u0E43\u0E2B\u0E49\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01\u0E43\u0E2B\u0E21\u0E48 \u0E21\u0E35\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19\u0E08\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E44\u0E14\u0E49 20%!',
  tutorial_facility_open_title: '\u0E40\u0E1B\u0E34\u0E14\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01',
  tutorial_facility_open_body: '\u0E40\u0E1B\u0E34\u0E14\u0E2A\u0E34\u0E48\u0E07\u0E2D\u0E33\u0E19\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E30\u0E14\u0E27\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21\u0E0A\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E15\u0E31\u0E49\u0E07\u0E23\u0E32\u0E04\u0E32\u0E44\u0E14\u0E49\u0E14\u0E49\u0E27\u0E22!',
  tutorial_done_title: '\u0E17\u0E33\u0E17\u0E34\u0E27\u0E17\u0E2D\u0E40\u0E23\u0E35\u0E22\u0E25\u0E40\u0E2A\u0E23\u0E47\u0E08!',
  tutorial_done_body: '\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21! \u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E02\u0E22\u0E32\u0E22\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E35\u0E2A\u0E34\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B!',
  tutorial_skip: '\u0E02\u0E49\u0E32\u0E21',
  tutorial_next: '\u0E15\u0E48\u0E2D\u0E44\u0E1B',
  tutorial_got_it: '\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08!',

  // === Story Arc System ===
  story_intro: '\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07',
  story_rising: 'พัฒนา',
  story_climax: 'จุดสูงสุด',
  story_resolution: 'คลี่คลาย',
  story_grade: 'โครงเรื่อง: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: 'ปลดล็อกระบบโครงเรื่อง!',
  story_guide_desc: 'เมื่อมี 4+ ห้อง จัดเรียงชั้นเพื่อสร้างโครงเรื่องและรับ SP โบนัส!',
  story_role_label: '{role}',
  story_intro_desc: 'สร้างบรรยากาศ: บรรยากาศสูง ความกลัวต่ำ',
  story_rising_desc: 'เพิ่มความตึงเครียด: เพิ่มความกลัวและความตื่นเต้น',
  story_climax_desc: 'จุดสูงสุดแห่งความกลัว: ความกลัวและความตื่นเต้นสูงสุด',
  story_resolution_desc: 'ปลดปล่อยและสนุก: เพิ่มความสนุก',
  story_room_role: 'บทบาทเรื่อง: {role}',
  story_none: 'ไม่มี',

  // === Room Available Props ===
  room_available_props: 'ติดตั้งได้: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: 'รอ: {n}/{max}',
  lq_avg_patience: 'ความอดทนเฉลี่ย: {n}%',
  lq_queue_empty: 'ไม่มีผู้เข้าชมในคิว',

  // === Lobby Facilities ===
  lf_title: 'สิ่งอำนวยความสะดวกล็อบบี้',
  lf_patience_bonus: 'ความอดทน -{n}%',
  lf_revenue_bonus: '+{n} SP/ผู้เข้าชม',
  lf_npc_bonus: 'NPC: +15% ความอดทน, +20% รายได้',
  lf_npc_staff: 'พนักงาน NPC',

  lf_ticket_booth: 'จุดขายตั๋ว',
  lf_ticket_booth_desc: 'เคาน์เตอร์จำหน่ายตั๋วที่จำเป็น',
  lf_waiting_lounge: 'ห้องรอ',
  lf_waiting_lounge_desc: 'พื้นที่รอสบายพร้อมที่นั่ง (+ความอดทน)',
  lf_vip_lounge: 'ห้อง VIP',
  lf_vip_lounge_desc: 'ห้องรอพรีเมียมสำหรับผู้เข้าชม VIP',
  lf_reservation_center: 'ศูนย์จอง',
  lf_reservation_center_desc: 'ระบบจองล่วงหน้าสำหรับผู้เข้าชม (+ความอดทน)',
  lf_poster_wall: 'ผนังโปสเตอร์',
  lf_poster_wall_desc: 'โปสเตอร์น่ากลัวเพิ่มความคาดหวัง (+ความอดทน)',
  lf_snack_cart: 'รถขนม',
  lf_snack_cart_desc: 'ขนมรักษาความอดทนของผู้เข้าชม',
  lf_souvenir_booth: 'บูธของที่ระลึก',
  lf_souvenir_booth_desc: 'ขายของที่ระลึกเพื่อรายได้เพิ่ม',
  lf_photo_zone: 'โซนถ่ายรูป',
  lf_photo_zone_desc: 'ผู้เข้าชมถ่ายรูปเพิ่มชื่อเสียงและรายได้',
  lf_tv_monitor: 'จอทีวี',
  lf_tv_monitor_desc: 'วิดีโอไฮไลท์ช่วยให้ผู้เข้าชมไม่เบื่อ',
  lf_costume_rental: 'เช่าชุดแฟนซี',
  lf_costume_rental_desc: 'ผู้เข้าชมเช่าชุดเพื่อความสนุกและรายได้เพิ่ม',
  lf_fortune_booth: 'บูธทำนายดวง',
  lf_fortune_booth_desc: 'การทำนายลึกลับสร้างบรรยากาศน่ากลัว',
  lf_built_badge: 'สร้างแล้ว',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: 'ความเร็วตั๋ว: ลดช่วงเวลาเข้า -15% ต่อเลเวล',
  lf_ue_max_queue_up: 'ความจุ: คิวสูงสุด +5 ต่อเลเวล',
  lf_ue_vip_rate_up: 'อัตรา VIP: อัตราการปรากฏ VIP x2 ต่อเลเวล',
  lf_ue_satisfaction_up: 'ความคาดหวัง: ความพอใจพื้นฐาน +20%',
  lf_ue_emergency_patience: 'ขนมฉุกเฉิน: +15 ความอดทนสำหรับผู้เข้าชมที่ต่ำ',
  lf_ue_revisit_rate_up: 'ของที่ระลึก: โบนัสผู้เข้าชมวันถัดไป +15%',
  lf_ue_reputation_per_day: 'แชร์ SNS: ชื่อเสียงรายวัน +2 ต่อเลเวล',
  lf_ue_anticipation_up: 'พรีวิวสยองขวัญ: เพิ่มความตื่นเต้น +40%',
  lf_ue_fun_bonus: 'ชุดแต่งกาย: สถิติความสนุก +15 ต่อเลเวล',
  lf_ue_random_sp_bonus: 'ทำนายดวง: โอกาสโบนัส SP สุ่ม +10%',
  ticket_price_setting: 'ตั้งราคาตั๋ว',

  // === Lobby Facility Props ===
  lobby_prop_candle: 'เทียน',
  lobby_prop_candle_desc: 'เทียนริบหรี่สร้างบรรยากาศ',
  lobby_prop_cobweb: 'ใยแมงมุม',
  lobby_prop_cobweb_desc: 'ใยแมงมุมน่าขนลุก',
  lobby_prop_pumpkin: 'ฟักทอง',
  lobby_prop_pumpkin_desc: 'โคมฟักทองคลาสสิก',
  lobby_prop_magazine_rack: 'ชั้นวางนิตยสาร',
  lobby_prop_magazine_rack_desc: 'นิตยสารสยองขวัญสำหรับรอ',
  lobby_prop_chandelier: 'โคมระย้า',
  lobby_prop_chandelier_desc: 'โคมระย้าแบบกอธิคสง่างาม',
  lobby_prop_wine_glass: 'แก้วไวน์',
  lobby_prop_wine_glass_desc: 'แก้วคริสตัลสำหรับบรรยากาศ VIP',
  lobby_prop_velvet_curtain: 'ม่านกำมะหยี่',
  lobby_prop_velvet_curtain_desc: 'ผ้ากำมะหยี่หรูหรา',
  lobby_prop_gold_frame: 'กรอบทอง',
  lobby_prop_gold_frame_desc: 'กรอบรูปทองประดับหรู',
  lobby_prop_picture_frame: 'กรอบรูป',
  lobby_prop_picture_frame_desc: 'ภาพเหมือนถูกสาปบนผนัง',
  lobby_prop_spotlight: 'สปอตไลท์',
  lobby_prop_spotlight_desc: 'แสงไฟดราม่าสำหรับการจัดแสดง',
  lobby_prop_skull_ornament: 'เครื่องประดับกะโหลก',
  lobby_prop_skull_ornament_desc: 'กะโหลกตกแต่งน่าขนลุก',
  lobby_prop_pumpkin_cookie: 'คุกกี้ฟักทอง',
  lobby_prop_pumpkin_cookie_desc: 'คุกกี้รูปฟักทองอร่อย',
  lobby_prop_ghost_drink: 'เครื่องดื่มผี',
  lobby_prop_ghost_drink_desc: 'เครื่องดื่มเรืองแสงลึกลับ',
  lobby_prop_napkin_holder: 'ที่ใส่กระดาษเช็ดมือ',
  lobby_prop_napkin_holder_desc: 'รักษาโซนขนมให้สะอาด',
  lobby_prop_display_shelf: 'ชั้นแสดงสินค้า',
  lobby_prop_display_shelf_desc: 'จัดแสดงของที่ระลึกอย่างน่าสนใจ',
  lobby_prop_plush_doll: 'ตุ๊กตา',
  lobby_prop_plush_doll_desc: 'ตุ๊กตาผีน่ารัก',
  lobby_prop_keychain_rack: 'ชั้นพวงกุญแจ',
  lobby_prop_keychain_rack_desc: 'ชั้นหมุนพวงกุญแจน่ากลัว',
  lobby_prop_wrapping_paper: 'กระดาษห่อของขวัญ',
  lobby_prop_wrapping_paper_desc: 'กระดาษห่อธีมฮาโลวีน',
  lobby_prop_backdrop: 'ฉากหลัง',
  lobby_prop_backdrop_desc: 'ฉากหลังถ่ายรูปตามธีม',
  lobby_prop_prop_box: 'กล่องอุปกรณ์',
  lobby_prop_prop_box_desc: 'กล่องอุปกรณ์ถ่ายรูปสนุก',
  lobby_prop_mask_stand: 'ขาตั้งหน้ากาก',
  lobby_prop_mask_stand_desc: 'จัดแสดงหน้ากากน่ากลัวสำหรับถ่ายรูป',
  lobby_prop_antenna: 'เสาอากาศ',
  lobby_prop_antenna_desc: 'ตัวรับสัญญาณทีวี',
  lobby_prop_remote_control: 'รีโมทคอนโทรล',
  lobby_prop_remote_control_desc: 'ควบคุมช่องทีวี',
  lobby_prop_speaker: 'ลำโพง',
  lobby_prop_speaker_desc: 'เสียงรอบทิศทางสำหรับหนังสยองขวัญ',
  lobby_prop_cable_wires: 'สายเคเบิล',
  lobby_prop_cable_wires_desc: 'สายไฟพันกันเพิ่มความน่ากลัว',
  lobby_prop_clothes_rack: 'ราวแขวนเสื้อ',
  lobby_prop_clothes_rack_desc: 'ราวแขวนชุดน่ากลัว',
  lobby_prop_mirror: 'กระจก',
  lobby_prop_mirror_desc: 'กระจกเต็มตัวสำหรับตรวจชุด',
  lobby_prop_makeup_table: 'โต๊ะแต่งหน้า',
  lobby_prop_makeup_table_desc: 'ที่สำหรับแต่งหน้าน่ากลัว',
  lobby_prop_wig_stand: 'ขาตั้งวิก',
  lobby_prop_wig_stand_desc: 'คอลเลกชันวิกน่ากลัว',
  lobby_prop_crystal_ball: 'ลูกแก้ว',
  lobby_prop_crystal_ball_desc: 'มองเห็นอนาคตน่ากลัวของคุณ',
  lobby_prop_tarot_cards: 'ไพ่ทาโรต์',
  lobby_prop_tarot_cards_desc: 'ไพ่ทำนายลึกลับ',
  lobby_prop_curtain: 'ม่าน',
  lobby_prop_curtain_desc: 'ม่านลึกลับสำหรับบูธทำนาย',
  lobby_prop_candelabra: 'เชิงเทียน',
  lobby_prop_candelabra_desc: 'เชิงเทียนหลายแขนสร้างบรรยากาศ',

  lnpc_title: 'Lobby Ghost Patrol',
  lnpc_assign: 'Assign Ghost',
  lnpc_unassign: 'Remove',
  lnpc_desc: 'Ghosts scare waiting visitors, boosting patience',
  lnpc_slot: '{cur}/{max} Ghosts',
  evt_time_remaining: '{sec}s remaining',
  evt_rain_name: 'Sudden Rain',
  evt_rain_desc: 'Heavy rain falls suddenly. Visitors without umbrellas are leaving the queue.',
  evt_rain_c1: 'Ignore',
  evt_rain_c2: 'Hand out umbrellas (100 SP)',
  evt_rain_r1: '3 visitors left the queue in the rain.',
  evt_rain_r2: 'Umbrellas were handed out. Everyone stays dry.',
  evt_couple_fight_name: 'Couple Fight',
  evt_couple_fight_desc: 'A couple starts arguing loudly in the queue, disturbing others.',
  evt_couple_fight_c1: 'Handle it',
  evt_couple_fight_r1: 'The situation has been dealt with.',
  evt_crying_child_name: 'Crying Child',
  evt_crying_child_desc: 'A child starts crying in the queue, making others uneasy.',
  evt_crying_child_c1: 'Give candy (50 SP)',
  evt_crying_child_c2: 'Ignore',
  evt_crying_child_r1: 'The candy cheered the child up.',
  evt_crying_child_r2: 'The crying continued, testing everyone\'s patience.',
  evt_blackout_name: 'Power Outage',
  evt_blackout_desc: 'A sudden power outage plunges everything into darkness.',
  evt_blackout_c1: 'Start generator (200 SP)',
  evt_blackout_c2: 'Wait it out',
  evt_blackout_r1: 'The generator kicked in. Business continues.',
  evt_blackout_r2: 'Everyone waited in the dark for a while.',
  evt_line_cutter_name: 'Line Cutter',
  evt_line_cutter_desc: 'Someone brazenly cuts into the front of the queue.',
  evt_line_cutter_c1: 'Call security',
  evt_line_cutter_c2: 'Ignore',
  evt_line_cutter_r1: 'Security escorted the line cutter out.',
  evt_line_cutter_r2: 'Others in line grumble in frustration.',
  evt_fake_ghost_name: 'Fake Ghost Prank',
  evt_fake_ghost_desc: 'A visitor dressed as a ghost is scaring others in line. The crowd seems amused.',
  evt_fake_ghost_c1: 'Let them have fun',
  evt_fake_ghost_r1: 'The prank added to the spooky atmosphere. Reputation up!',
  evt_lost_item_name: 'Lost Item Report',
  evt_lost_item_desc: 'A visitor reports a lost item near the entrance.',
  evt_lost_item_c1: 'Help find it (Reputation +5)',
  evt_lost_item_c2: 'Ignore',
  evt_lost_item_r1: 'The lost item was found! The visitor is grateful.',
  evt_lost_item_r2: 'The visitor left disappointed.',
  evt_snack_sold_out_name: 'Snacks Sold Out',
  evt_snack_sold_out_desc: 'The snack cart ran out of stock. Visitors are asking for snacks.',
  evt_snack_sold_out_c1: 'Emergency restock (100 SP)',
  evt_snack_sold_out_c2: 'Wait for next shipment',
  evt_snack_sold_out_r1: 'Snacks are back in stock.',
  evt_snack_sold_out_r2: 'Visitors will have to wait.',
  evt_sns_selfie_name: 'SNS Photo Op',
  evt_sns_selfie_desc: 'A visitor wants to take a selfie for social media.',
  evt_sns_selfie_c1: 'Acknowledge',
  evt_sns_selfie_r1: 'The post boosted your online presence.',
  evt_hot_weather_name: 'Scorching Heat',
  evt_hot_weather_desc: 'The temperature soars. Visitors look uncomfortable in the heat.',
  evt_hot_weather_c1: 'Free drinks (150 SP)',
  evt_hot_weather_c2: 'Endure it',
  evt_hot_weather_r1: 'Cool drinks refreshed everyone.',
  evt_hot_weather_r2: 'The heat is taking a toll on patience.',
  evt_tour_bus_name: 'Tour Bus Arrival',
  evt_tour_bus_desc: 'A tour bus just arrived! A large group of tourists floods the entrance.',
  evt_tour_bus_c1: 'Welcome them',
  evt_tour_bus_r1: 'The queue fills up with excited tourists.',
  evt_tv_coverage_name: 'TV Crew Request',
  evt_tv_coverage_desc: 'A local TV station wants to cover your haunted house.',
  evt_tv_coverage_c1: 'Accept (risky)',
  evt_tv_coverage_c2: 'Decline',
  evt_tv_coverage_r1: 'The coverage aired. Results vary...',
  evt_tv_coverage_r2: 'You politely declined the offer.',
  evt_spy_name: 'Rival Spy',
  evt_spy_desc: 'You spot someone suspiciously taking notes about your operations.',
  evt_spy_c1: 'Apprehend (need security)',
  evt_spy_c2: 'Ignore',
  evt_spy_r1: 'The spy was caught. You recovered valuable intel.',
  evt_spy_r2: 'Some of your ideas might leak to competitors.',
  evt_health_inspection_name: 'Health Inspection',
  evt_health_inspection_desc: 'Health inspectors arrive for a surprise visit.',
  evt_health_inspection_c1: 'Open the doors',
  evt_health_inspection_r1: 'The inspection is complete.',
  evt_halloween_season_name: 'Halloween Fever',
  evt_halloween_season_desc: 'Halloween spirit fills the air! Everyone is in the mood for scares.',
  evt_halloween_season_c1: 'Celebrate!',
  evt_halloween_season_r1: 'Halloween boost! Extra visitors and SP incoming.',
  evt_ghost_strike_name: 'Ghost Strike',
  evt_ghost_strike_desc: 'Overworked ghosts are refusing to scare. They demand better conditions.',
  evt_ghost_strike_c1: 'Pay bonus (500 SP)',
  evt_ghost_strike_c2: 'Wait it out',
  evt_ghost_strike_r1: 'The bonus satisfied the ghosts. Back to work!',
  evt_ghost_strike_r2: 'The strike continues for a while...',
  evt_mystery_visitor_name: 'Mystery Critic',
  evt_mystery_visitor_desc: 'A famous horror critic is visiting in disguise. Results depend on your reputation.',
  evt_mystery_visitor_c1: 'Best behavior',
  evt_mystery_visitor_r1: 'The critic revealed themselves and wrote a review.',
  evt_maintenance_accident_name: 'Equipment Malfunction',
  evt_maintenance_accident_desc: 'A piece of equipment malfunctioned in one of the rooms!',
  evt_maintenance_accident_c1: 'Assess damage',
  evt_maintenance_accident_r1: 'A room sustained damage. Repairs needed.',
  evt_sns_viral_name: 'Viral Video',
  evt_sns_viral_desc: 'A visitor\'s video of your haunted house went viral online!',
  evt_sns_viral_c1: 'Ride the wave',
  evt_sns_viral_r1: 'Your fame skyrockets! Reputation and SP boosted.',
  evt_total_blackout_name: 'Total Blackout',
  evt_total_blackout_desc: 'All power goes out across the entire area. Complete darkness.',
  evt_total_blackout_c1: 'Candlelight event (+Rep)',
  evt_total_blackout_c2: 'Wait for power',
  evt_total_blackout_r1: 'The candlelight atmosphere was a hit!',
  evt_total_blackout_r2: 'Everyone waited in the dark.',
  evt_famous_youtuber_name: 'Famous Streamer',
  evt_famous_youtuber_desc: 'A famous horror streamer with millions of followers is live-streaming from your haunted house!',
  evt_famous_youtuber_c1: 'Give VIP treatment',
  evt_famous_youtuber_r1: 'The stream was a massive hit! Reputation +30, SP +2000.',
  evt_celeb_visit_name: 'Celebrity Visit',
  evt_celeb_visit_desc: 'A major celebrity has arrived for a private scare session!',
  evt_celeb_visit_c1: 'Roll out the red carpet',
  evt_celeb_visit_r1: 'The celebrity loved it! Huge publicity boost.',
  evt_franchise_offer_name: 'Franchise Offer',
  evt_franchise_offer_desc: 'A corporation wants to franchise your haunted house brand.',
  evt_franchise_offer_c1: 'Accept (10000 SP)',
  evt_franchise_offer_c2: 'Decline',
  evt_franchise_offer_r1: 'Deal signed! A hefty payment arrives.',
  evt_franchise_offer_r2: 'You prefer to stay independent.',
  evt_intl_contest_name: 'International Horror Contest',
  evt_intl_contest_desc: 'Your haunted house is invited to an international scare competition!',
  evt_intl_contest_c1: 'Enter the contest',
  evt_intl_contest_r1: 'You earned recognition on the world stage!',
  evt_documentary_name: 'Documentary Filming',
  evt_documentary_desc: 'A documentary crew wants to film the story of your haunted house.',
  evt_documentary_c1: 'Allow filming',
  evt_documentary_r1: 'The documentary premieres to rave reviews!',
  evt_ghost_king_name: 'The Ghost King Appears',
  evt_ghost_king_desc: 'A legendary ghost is drawn to your haunted house by its fame.',
  evt_ghost_king_c1: 'Welcome the Ghost King',
  evt_ghost_king_r1: 'The Ghost King joins your ranks! Morale soars.',
  evt_gov_subsidy_name: 'Government Grant',
  evt_gov_subsidy_desc: 'The tourism board awards your haunted house a cultural preservation grant.',
  evt_gov_subsidy_c1: 'Accept the grant',
  evt_gov_subsidy_r1: 'Grant received: 5000 SP!',
  evt_vip_party_name: 'VIP Party Request',
  evt_vip_party_desc: 'A wealthy patron wants to rent the entire haunted house for a private party.',
  evt_vip_party_c1: 'Accept (8000 SP)',
  evt_vip_party_c2: 'Decline',
  evt_vip_party_r1: 'The VIP party was a huge success!',
  evt_vip_party_r2: 'You keep the doors open for regular visitors.',
  evt_horror_festival_name: 'Horror Festival',
  evt_horror_festival_desc: 'The city is hosting a horror festival and your haunted house is the main attraction!',
  evt_horror_festival_c1: 'Lead the festival',
  evt_horror_festival_r1: 'The festival was legendary! Massive rewards earned.',
  evt_legendary_review_name: 'Legendary Review',
  evt_legendary_review_desc: 'The world\'s most famous horror critic publishes a glowing review of your haunted house.',
  evt_legendary_review_c1: 'Bask in glory',
  evt_legendary_review_r1: 'A flood of 5-star reviews and fame follows!',

  // === Event Defense System ===
  evt_defense_badge: 'Auto-Resolved!',
  evt_defense_bonus: 'Bonus: +{sp} SP',
  evt_rain_defense: 'The roof upgrade keeps everyone dry. No one leaves!',
  evt_rain_hint: 'Tip: Upgrade Poster Wall to Lv.3 to auto-defend against rain.',
  evt_couple_fight_defense: 'Security steps in and mediates the situation calmly.',
  evt_couple_fight_hint: 'Tip: Hire a Security guard to auto-resolve fights.',
  evt_crying_child_defense: 'The snack cart attendant offers candy. The child smiles!',
  evt_crying_child_hint: 'Tip: Build a Snack Cart to automatically comfort crying children.',
  evt_blackout_defense: 'Emergency generators kick in automatically. No interruption!',
  evt_blackout_hint: 'Tip: Upgrade facilities to total Lv.10+ for backup power.',
  evt_line_cutter_defense: 'Security handles the line cutter immediately. Order restored!',
  evt_line_cutter_hint: 'Tip: Hire a Security guard to auto-handle line cutters.',
  evt_fake_ghost_defense: 'Your real NPC ghosts outshine the impostor. Excitement rises!',
  evt_fake_ghost_hint: 'Tip: Assign at least 1 NPC ghost to the lobby to overshadow fakers.',
  evt_lost_item_defense: 'Your staff quickly locates and returns the lost item!',
  evt_lost_item_hint: 'Tip: Hire 3+ staff members to auto-find lost items.',
  evt_snack_sold_out_defense: 'Inventory auto-restocked from reserves. Sales continue!',
  evt_snack_sold_out_hint: 'Tip: Upgrade Snack Cart to Lv.2+ for auto-restocking.',
  evt_sns_selfie_defense: 'Photo Zone provides the perfect backdrop. Great shots posted!',
  evt_sns_selfie_hint: 'Tip: Build a Photo Zone for automatic photo opportunities.',
  evt_hot_weather_defense: 'The monitor area has air conditioning. Everyone stays cool!',
  evt_hot_weather_hint: 'Tip: Install a TV Monitor to provide a cooled waiting area.',
  evt_tour_bus_defense: 'Plenty of room! All tourists are welcomed in.',
  evt_tour_bus_hint: 'Tip: Expand queue capacity to 15+ to accept large groups.',
  evt_tv_coverage_defense: 'With great reputation and many ghosts, the broadcast is a hit!',
  evt_tv_coverage_hint: 'Tip: Reach reputation 50+ and hire 5+ ghosts for guaranteed success.',
  evt_spy_defense: 'Security catches the spy red-handed! Intel recovered.',
  evt_spy_hint: 'Tip: Hire a Security guard to auto-detect spies.',
  evt_health_inspection_defense: 'Spotless! The inspector awards a hygiene certificate.',
  evt_health_inspection_hint: 'Tip: Hire a Janitor and keep average hygiene above 70.',
  evt_ghost_strike_defense: 'Ghosts are well-rested and happy. No strike today!',
  evt_ghost_strike_hint: 'Tip: Keep average ghost fatigue below 30 to prevent strikes.',
  evt_mystery_visitor_defense: 'Your excellent reputation earns a glowing review!',
  evt_mystery_visitor_hint: 'Tip: Maintain reputation at 60+ for guaranteed good reviews.',
  evt_maintenance_accident_defense: 'The repairman fixes it on the spot. Minimal damage!',
  evt_maintenance_accident_hint: 'Tip: Hire a Repairman to minimize equipment damage.',
  evt_total_blackout_defense: 'Repairman restores power instantly. Candle event bonus!',
  evt_total_blackout_hint: 'Tip: Hire a Repairman and reach facility Lv.15+ total.',
  evt_vip_party_defense: 'Costumes and photo zone make the party unforgettable! Normal business continues too.',
  evt_vip_party_hint: 'Tip: Build Costume Rental and Photo Zone for the ultimate party.',

  // === World Street ===
  world_title: 'อาคาร',
  world_subtitle: 'เลือกอาคารที่ต้องการจัดการ',
  world_empty_plot: 'ที่ดินว่าง',
  world_build_new: 'สร้างบ้านผีสิงธีมใหม่',

  rename_building: 'เปลี่ยนชื่ออาคาร',
  rename_building_desc: 'กรอกชื่ออาคารใหม่',
  rename: 'ยืนยัน',
  building_renamed: 'เปลี่ยนชื่อแล้ว',

  construction_title: 'สร้างอาคารใหม่',
  construction_subtitle: 'สร้างบ้านผีสิงแห่งใหม่!',
  construction_name_label: 'ชื่ออาคาร',
  construction_name_placeholder: 'เช่น คฤหาสน์เที่ยงคืน',
  construction_theme_label: 'ธีม',
  construction_start: 'สร้าง',
  world_status_build: 'สร้าง',
  world_status_open: 'เปิดให้บริการ',
  world_status_ready: 'เตรียมการ',
  theme_haunted_house: 'บ้านผีสิง',
  theme_haunted_house_desc: 'ประสบการณ์ผีสิงแบบคลาสสิก',
  theme_abandoned_hospital: 'โรงพยาบาลร้าง',
  theme_abandoned_hospital_desc: 'บรรยากาศสยองขวัญทางการแพทย์',
  theme_school_back_mountain: 'ภูเขาหลังโรงเรียน',
  theme_school_back_mountain_desc: 'ตำนานผีโรงเรียนและเส้นทางภูเขา',
  theme_cursed_circus: 'ละครสัตว์ต้องสาป',
  theme_cursed_circus_desc: 'ความน่ากลัวประหลาดของเต๊นท์ละครสัตว์ต้องสาป',
  theme_ancient_temple: 'วัดโบราณ',
  theme_ancient_temple_desc: 'คำสาปลึกลับและน่าขนลุกของวัดโบราณ',
  theme_pirate_ship: 'เรือโจรสลัด',
  theme_pirate_ship_desc: 'ความน่ากลัวในทะเลของเรือโจรสลัดต้องสาป',
  theme_abandoned_mine: 'เหมืองร้าง',
  theme_abandoned_mine_desc: 'ความมืดลึกของเหมืองร้าง',
  theme_gothic_castle: 'ปราสาทโกธิค',
  theme_gothic_castle_desc: 'ความน่ากลัวของชนชั้นสูงในปราสาทโกธิค',
  theme_underground_bunker: 'บังเกอร์ใต้ดิน',
  theme_underground_bunker_desc: 'การทดลองและแผนร้ายใต้ดิน',
  theme_cursed_forest: 'ป่าต้องสาป',
  theme_cursed_forest_desc: 'วิญญาณธรรมชาติและความน่ากลัวดั้งเดิม',

  synergy_active_count: '{n} ซินเนอร์จี้ ทำงานอยู่',
  synergy_popup_title: 'ซินเนอร์จี้ที่ทำงานอยู่',
  syn_fx_dark_mirror_e1: 'ภาพลวงตาแห่งกระจก',
  syn_fx_dark_mirror_e2: 'คำสาปแฝดร้าย',
  syn_fx_underground_horror_e1: 'เสียงกรีดในคุกใต้ดิน',
  syn_fx_underground_horror_e2: 'เสียงสะท้อนแห่งความตาย',
  syn_fx_restless_spirits_e1: 'ลมหายใจของคนตาย',
  syn_fx_restless_spirits_e2: 'ขบวนภูตผี',
  syn_fx_creepy_collection_e1: 'คำสาปตุ๊กตา',
  syn_fx_creepy_collection_e2: 'เขาวงกตในกระจก',
  syn_fx_mad_scientist_e1: 'การทดลองบ้าคลั่ง',
  syn_fx_mad_scientist_e2: 'รางวัลแห่งการเล่นแร่แปรธาตุ',
  syn_fx_hidden_paths_e1: 'เขาวงกตเงามืด',
  syn_fx_hidden_paths_e2: 'ความน่ากลัวที่ซ่อนอยู่',
  syn_fx_circus_nightmare_e1: 'เกมตลกจ๋า',
  syn_fx_circus_nightmare_e2: 'ฝันร้ายสวนสนุก',
  syn_fx_ancient_curse_e1: 'คำสาปโบราณ',
  syn_fx_ancient_curse_e2: 'พิโรธมัมมี่',
  syn_fx_hidden_treasures_e1: 'ล่อลวงขุมทรัพย์',
  syn_fx_hidden_treasures_e2: 'การค้นพบใต้ดิน',
  syn_fx_ship_of_doom_e1: 'บทเพลงศพแห่งทะเล',
  syn_fx_ship_of_doom_e2: 'การลงโทษของเดวี่ โจนส์',
  syn_fx_prison_horror_e1: 'หนีคุก',
  syn_fx_prison_horror_e2: 'โซ่พันธนาการ',
  syn_fx_deep_descent_e1: 'แสงคริสตัล',
  syn_fx_deep_descent_e2: 'ความลึกลับใต้ดิน',
  syn_fx_boom_scare_e1: 'ผลกระทบจากระเบิด',
  syn_fx_boom_scare_e2: 'ระเบิดลูกโซ่',
  syn_fx_royal_terror_e1: 'พระพิโรธกษัตริย์',
  syn_fx_royal_terror_e2: 'ขุมทรัพย์หลวง',
  syn_fx_noble_cellar_e1: 'กลิ่นไวน์หมัก',
  syn_fx_noble_cellar_e2: 'ห้องเก็บไวน์ลับ',
  syn_fx_quarantine_protocol_e1: 'เตือนภัยกักกัน',
  syn_fx_quarantine_protocol_e2: 'ภัยชีวภาพ',
  syn_fx_nature_wrath_e1: 'หมอกแม่มด',
  syn_fx_nature_wrath_e2: 'พิโรธธรรมชาติ',
  syn_fx_ancient_power_e1: 'พลังบรรพกาล',
  syn_fx_ancient_power_e2: 'ซากปรักหักพังศักดิ์สิทธิ์',
  syn_fx_echo_chamber_e1: 'คำสาปเสียงสะท้อน',
  syn_fx_echo_chamber_e2: 'ภาพลวงตาเสียง',
  syn_fx_water_horror_e1: 'สยองแห่งเหวลึก',
  syn_fx_water_horror_e2: 'กระซิบแห่งน้ำ',
  syn_fx_full_course_e1: 'งานเลี้ยงเต็มรูปแบบ',
  syn_fx_full_course_e2: 'รอยยิ้มแห่งความพึงพอใจ',
  synergy_dark_mirror: 'กระจกมืด',
  synergy_dark_mirror_desc: 'ทางเดินมืด + ห้องกระจก: บรรยากาศ+15%, ความกลัว+10%',
  synergy_underground_horror: 'สยองใต้ดิน',
  synergy_underground_horror_desc: 'คุกใต้ดิน/โลงไม้ชุด: ความกลัว+20%, ตื่นเต้น+10%',
  synergy_restless_spirits: 'วิญญาณกระสะใจ',
  synergy_restless_spirits_desc: 'สุสาน/โลงไม้/ห้องเก็บศพ: บรรยากาศ+20%, ผู้เยี่ยม+10%',
  synergy_creepy_collection: 'คอลเลกชันขลุขลุ',
  synergy_creepy_collection_desc: 'ตุกตุก/กระจก/บ้านสนุก: ความกลัว+15%, ตื่นเต้น+10%',
  synergy_mad_scientist: 'นักวิทยาศาสตร์บ้า',
  synergy_mad_scientist_desc: 'แล็บ/ห้องผ่าตัด/วิทยาศาสตร์: ตื่นเต้น+20%, SP+15%',
  synergy_hidden_paths: 'เส้นทางลับ',
  synergy_hidden_paths_desc: 'ทางลับ/ทางเดิน/ใต้หลังคา: บรรยากาศ+15%, ลูกโซ่+20%',
  synergy_circus_nightmare: 'ฝันร้ายสายคัง',
  synergy_circus_nightmare_desc: 'บ้านสนุก/รายการสยอง/ทราพีซ: สนุก+20%, ความกลัว+15%',
  synergy_ancient_curse: 'คำสาปโบราณ',
  synergy_ancient_curse_desc: 'แท่นบูชา/ห้องคำสาป/หลุมฝังศพมัมมี่: ความกลัว+25%, ตื่นเต้น+15%',
  synergy_hidden_treasures: 'สมบัติลับ',
  synergy_hidden_treasures_desc: 'ห้องนิรภัย + แม่น้ำใต้ดิน: SP+20%, ผู้เยี่ยม+10%',
  synergy_ship_of_doom: 'เรือแห่งความตาย',
  synergy_ship_of_doom_desc: 'กัปตัน/สินค้า/เดวี่: บรรยากาศ+15%, ความกลัว+15%',
  synergy_prison_horror: 'ความกลัวในคุก',
  synergy_prison_horror_desc: 'ห้องขัง + เดวี่: ตื่นเต้น+20%, ความคุกคาม+10%',
  synergy_deep_descent: 'ดิ่งลงไปข้างล่าง',
  synergy_deep_descent_desc: 'เหมือง/ถ้ำผลึก/ทะเลสาบ: บรรยากาศ+20%, ผู้เยี่ยม+15%',
  synergy_boom_scare: 'ระเบิดตกใจ',
  synergy_boom_scare_desc: 'คลังระเบิด + อุโมงค์: ตื่นเต้น+25%, ลูกโซ่+15%',
  synergy_royal_terror: 'ความกลัวหลวง',
  synergy_royal_terror_desc: 'บัลลังก์/หอคอย/ไวน์: ความกลัว+15%, SP+20%',
  synergy_noble_cellar: 'ห้องใต้ดินขุนนาง',
  synergy_noble_cellar_desc: 'ห้องไวน์ + ทางลับ: บรรยากาศ+15%, SP+10%',
  synergy_quarantine_protocol: 'โปรโตคอลกักกัน',
  synergy_quarantine_protocol_desc: 'เซิร์ฟเวอร์/เขตกักกัน/คลังแสง: ตื่นเต้น+20%, ความกลัว+10%',
  synergy_nature_wrath: 'พิโรธธรรชชาติ',
  synergy_nature_wrath_desc: 'แม่มด/บึง/นางฟ้า: บรรยากาศ+20%, ความคุกคาม+10%',
  synergy_ancient_power: 'พลังโบราณ',
  synergy_ancient_power_desc: 'ซากปรัก/นางฟ้า/แท่นบูชา: ความกลัว+20%, ผู้เยี่ยม+15%',
  synergy_echo_chamber: 'ห้องสะท้อน',
  synergy_echo_chamber_desc: 'ดนตรี/ห้องสมุด/ทางเดิน: ลูกโซ่+25%, บรรยากาศ+10%',
  synergy_water_horror: 'ความกลัวน้ำ',
  synergy_water_horror_desc: 'ห้องน้ำ/แม่น้ำใต้ดิน/ทะเลสาบ: ความกลัว+15%, บรรยากาศ+15%',
  synergy_full_course: 'คอร์สเต็ม',
  synergy_full_course_desc: 'ครัว/ห้องน้ำ/ดนตรี: สนุก+25%, ผู้เยี่ยม+20%',
};

export default th;
